/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import Layout from 'components/Layout';
import { ButtonContent, AddButton, RefreshButton } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import BrokingSummary from 'components/BrokingSummary';
import Icon from 'components/Icon';
import { camelCase, isEmpty, cloneDeep, uniqueId } from 'lodash';
import moment from 'moment';
import * as yup from 'yup';
import {
    FormSectionGlobal as FormSection,
    FormContainer,
    GroupFormContainer,
    ContentCard,
    Button,
    ButtonContainer,
    LostCancelButton,
    HasPermission,
    NotesAccordion,
    NotesModal,
    Label,
    Clauses,
    ModalConfirmation
} from '@fitinsur/components'
import {
    LoaderContext
} from '@fitinsur/contexts'
import { useGetQuestionnairesByIdProduct } from 'services/QuestionnairesService';
import { useVerifyRiskAcceptance } from 'services/RiskAcceptanceService';
import { useGetCommercialPlansByIdOperationSync } from 'services/CommercialPlansService';
import { useCalculateSync, useCalculateCancellationSync } from 'services/PremiumCalculationService';
import {
    groupMultipleFieldQuestions,
    handleQuestionBlur,
    handleQuestionChange,
    handleQuestionsInitialAdjustments,
    handleRequestSerproCnpj,
    handleSearchZipCode,
    onValidationError,
    removeAnswersDuplicateSession,
    sectionIsVisible,
    handleGetCoverageMaxLimClaim
} from './handleQuestionChange';
import { isNumber } from '@fitinsur/utils';
import {
    useSaveOperations,
    useGetOperationAsync,
    useUpdateOperationSync,
    useResetOperationState,
    useGetOperationsAsync,
    useSaveOperationsAsync
} from '@fitinsur/services/OperationService';
import Colors from "../../constants/Colors";
import { useGetPersonsSync } from '@fitinsur/services/PersonService';
import { useGetDocumentsParams, useGetDocumentsAsync } from '@fitinsur/services/DocumentsService';
import {
    useGetQuestionnaireAnswer,
    useCompareQuestionnairesByIdOperationSync
} from '@fitinsur/services/QuestionnaireAnswerService';
import {
    useMaxLimClaim,
} from '@fitinsur/services/PremiumCalculationService';
import {
    useGetDatajudProcessInfo,
} from '@fitinsur/services/CNJService';
import { TotalContainer } from './styles';
import {
    useGenerateQuoteASync,
    useCreateQuoteOperation,
    useUpdateQuoteOperation
} from '@fitinsur/services/QuoteService';
import {
    useUpdateDocumentsClausesSync
} from 'services/ClausesService';
import {
    useGetMonetaryCorrectionAsync,
    useGetQuery
} from '@fitinsur/services/QuestionnairesService';
import {
    useRequestSompoGetInternalProcessNumber,
} from 'services/IssueService';
import {
    useCheckConsumption
} from '@fitinsur/services/CreditLimitService';
import {
    useGetBorrowerByIdPerson
} from '@fitinsur/services/EconomicGroupService';
import {
    useGetProductPlanVigencyParamsSync
} from '@fitinsur/services/ProductPlanService';
import {
    useGetBorrowerBrokerByIdOperation
} from 'services/CreditAnalysisService';
import { useLostOperation } from '@fitinsur/services/OperationService';
import {
    useGetInterpolationLimits,
} from 'services/QuestionnairesService';
import { ExcelReader } from '@fitinsur/components/ExcelReader';

const questionKeyMap = {
    3439: "cep",
    3440: "logradouro",
    3441: "numero",
    3442: "complemento",
    3443: "bairro",
    3444: "cidade",
    3445: "estado",
    3446: "pais",
    3468: "atividade local de risco"
};

/**
 * Mapeamento entre atividades do local de risco e atividades principais
 * Baseado nas regras de negócio definidas pela equipe de produto
 * Formato: { idAnswerOptionLocalRisco: idAnswerOptionAtividadePrincipal }
 */
const RISK_TO_MAIN_ACTIVITY_MAPPING = {
    9020: 8929,
    9021: 8930,
    9022: 9018,
    9023: 9019
};

export default function EditEnquirity({ permissions, match, ...props }) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const [beneficiary, setBeneficiary] = useState([]);
    const [externalEntityGroup, setExternalEntityGroup] = useState([]);
    const [coInsuredGroup, setCoInsuredGroup] = useState([]);
    const [coInsurerGroup, setCoInsurerGroup] = useState([]);
    const [coBrokerGroup, setCoBrokerGroup] = useState([]);
    const [selectedBrokers, setSelectedBrokers] = useState([]);
    const [selectedCoInsurers, setSelectedCoInsurers] = useState([]);
    const [coInsuredNumber, setCoInsuredNumber] = useState(0);
    const [beneficiaryNumber, setBeneficiaryNumber] = useState(0);
    const [cashCollateralNumber, setCashCollateralNumber] = useState(0);
    const [coBrokerNumber, setCoBrokerNumber] = useState(0);
    const [coInsurerNumber, setCoInsurerNumber] = useState(0);
    const [riskGroupNumber, setRiskGroupNumber] = useState(0);

    const [selectedCoInsurersPercentage, setSelectedCoInsurersPercentage] = useState([]);
    const [cashCollateralGroup, setCashCollateralGroup] = useState([]);
    const [partners, setPartners] = useState([]);
    const [isAwaitingAnalysis, setIsAwaitingAnalysis] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [questionnaire, setQuestionnaire] = useState([]);
    const [operation, setOperation] = useState(null);
    const [idOperation, setIdOperation] = useState(match.params?.idOperation || null);
    const [notesModal, setNotesModal] = useState(false);
    const [product, setProduct] = useState({});
    const [isBound, setIsBound] = useState(false);
    const [hasSubscribeRatingAnswer, setHasSubscribeRatingAnswer] = useState(null);
    const [attachmentsIsVisible, setAttachmentsIsVisible] = useState(false);
    const [periodicityText, setPeriodicityText] = useState('-');
    const [infoRequiredDocs, setInfoRequiredDocs] = useState('');
    const [clausesLoading, setClausesLoading] = useState(false);
    const [selectedClauses, setSelectedClauses] = useState([]);
    const goToNextPage = useRef(false);
    const sendEndorsementToAnalysis = useRef(false);
    const emissionDates = useRef({
        inceptionDate: null,
        expiryDate: null
    });
    const vigencyParams = useRef({
        productPlanVigencyMin: null,
        productPlanVigencyMax: null,
        productPlanVigencyDefault: null,
        maxRetroactiveDate: null
    });
    const monetaryCorrectionErrorMsg = useRef('');
    const refOperationData = useRef(null);
    const getQuestionnaire = useRef(false);
    const questionnaireSent = useRef(false);
    const [currentModality, setCurrentModality] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [totalPercentage, setTotalPercentage] = useState(0);
    const [updateButtons, setUpdateButtons] = useState(false);
    const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]);
    const [modalConfirmation, setModalConfirmation] = useState(false);
    const [forceLoading, setForceLoading] = useState(null);
    const authContext = useContext(GlobalAuthContext);
    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    const formikRef = useRef();
    const location = useLocation();
    const refOperation = new URLSearchParams(location.search).get('refOperation');
    const handleBack = () => history.goBack();
    const isClient = authContext.enumProfile === 1 ? true : false;
    const [invalidEmails, setInvalidEmails] = useState([]);
    const [brokerList, setBrokerList] = useState([]);
    const [invalidBrokers, setInvalidBrokers] = useState([]);
    const [invalidCoInsurers, setInvalidCoInsurers] = useState([]);
    const [riskGroup, setRiskGroup] = useState([]);
    const [selectedRiskGroup, setSelectedRiskGroup] = useState(null);
    const [systemDateReference, setSystemDateReference] = useState(new Date());
    const [forceChangeExcelData, setForceChangeExcelData] = useState(false);

    const notEditRiskOnRenewal = questionnaire.find(
        qst => qst.idQuestion === 1854
    )?.idAnswerOption === 7467;

    const GENERATE_PERMISSION = useMemo(() => {
        if (!operation) return permissions.NBI_REQUEST_APPROVE_REJECT;
        return operation?.idDomain === 26 ? permissions.NBI_REQUEST_APPROVE_REJECT : permissions.GENERATE_ENDORSEMENT;
    }, [operation?.idDomain, permissions.NBI_REQUEST_APPROVE_REJECT, permissions.GENERATE_ENDORSEMENT]);

    const EDIT_PERMISSION = useMemo(() => {
        if (!operation) return permissions.EDIT_ENQUIRY_SAVE;
        return operation?.idDomain === 26 ? permissions.EDIT_ENQUIRY_SAVE : permissions.EDIT_ENDORSEMENT_SAVE;
    }, [operation?.idDomain, permissions.EDIT_ENQUIRY_SAVE, permissions.EDIT_ENDORSEMENT_SAVE]);

    const CANCEL_ENDORSEMENT = useMemo(() => {
        if (!operation) return permissions.CANCEL_ENQUIRY;
        return operation?.idDomain === 26 ? permissions.CANCEL_ENQUIRY : permissions.CANCEL_ENDORSEMENT;
    }, [operation?.idDomain, permissions.CANCEL_ENQUIRY, permissions.CANCEL_ENDORSEMENT]);

    const disableAll = useMemo(() => {
        return isBound || (isAwaitingAnalysis && !(GENERATE_PERMISSION && operation?.isRenewal)) || hasPermission || (!isEdit && !(GENERATE_PERMISSION && operation?.isRenewal));
    }, [isBound, isAwaitingAnalysis, GENERATE_PERMISSION, operation?.isRenewal, hasPermission, isEdit]);

    const SECTIONS = {
        BORROWER_CLAIMANT: { name: 'BORROWER_CLAIMANT', fullName: "Dados do Proponente / Tomado", isMultiple: false, isRisk: false },
        OPERATION: { name: 'OPERATION', fullName: "Dados da Operação", isMultiple: false, isRisk: false },
        CLAIMANT: { name: 'CLAIMANT', fullName: "Dados da Reclamante", isMultiple: false, isRisk: false },
        BORROWER: { name: 'BORROWER', fullName: "Dados do Proponente / Tomado", isMultiple: false, isRisk: false },
        PROCESS: { name: 'PROCESS', fullName: "Dados do Processo", isMultiple: false, isRisk: false },
        LEGAL: { name: 'LEGAL', fullName: "Parecer Jurídico", isMultiple: false, isRisk: false },
        INFORMATION: { name: 'INFORMATION', fullName: "Dados do Patrocinador da Causa", isMultiple: false, isRisk: false },
        RISKS: { name: 'RISKS', fullName: "Dado de risco", isMultiple: false, isRisk: false },
        ATTACHMENT: { name: 'ATTACHMENT', fullName: "Dados da Operação", isMultiple: false, isRisk: false },
        CO_INSURED: { name: 'CO_INSURED', fullName: "Co-segurado", isMultiple: true, isRisk: false },
        BENEFICIARY: { name: 'BENEFICIARY', fullName: "Beneficiário", isMultiple: true, isRisk: false },
        INSURED: { name: 'INSURED', fullName: "Segurado", isMultiple: false, isRisk: false },
        SUMMARY: { name: 'SUMMARY', fullName: "Resumo", isMultiple: false, isRisk: false },
        CONTRACT: { name: 'CONTRACT', fullName: "Dados do Contrato", isMultiple: false, isRisk: false },
        CASH_COLLATERAL: { name: 'CASH_COLLATERAL', fullName: "Garantia Colateral", isMultiple: true, isRisk: false },
        ANALYSIS_INFO: { name: 'ANALYSIS_INFO', fullName: "Dados da Operação", isMultiple: false, isRisk: false },
        CO_INSURER: { name: 'CO_INSURER', fullName: "Informações do Cosseguro", isMultiple: true, isRisk: false },
        PARTICIPATION: { name: 'PARTICIPATION', fullName: "Informações do Cosseguro", isMultiple: false, isRisk: false },
        CO_BROKERS: { name: 'CO_BROKERS', fullName: "Informações do Co-corretor", isMultiple: true, isRisk: false },
        RISK_LOCATION: { name: 'RISK_LOCATION', fullName: "Localização do Risco", isMultiple: true, isRisk: false },
    };

    const getQuestionUniqueKey = (question, index) => {
        const key = `${camelCase(question.dsQuestion)}${index != null ? `_${index}` : ""}_${uniqueId()}`;
        formikRef.current.setFieldValue(key, question.behaviorObject?.defaultValue || "");
        return key;
    };

    const disableButton = (operation) => {
        if (isClient && operation?.idDomain !== 26) return true;
        if (isClient && operation?.idDomainStatus && operation?.idDomainStatus !== 1 && operation?.idDomainStatus !== 8) return true;
        return false
    }

    const queryStringToJSON = () => {
        var pairs = location.search.slice(1).split('&');

        var result = {};
        pairs.forEach(pair => {
            pair = pair.split('=');
            result[pair[0]] = decodeURIComponent(pair[1] || '');
        });

        return JSON.parse(JSON.stringify(result));
    }

    const { back } = queryStringToJSON();

    const {
        loading: useRequestSompoGetInternalProcessNumberLoading,
        request: useRequestSompoGetInternalProcessNumberRequest,
    } = useRequestSompoGetInternalProcessNumber();

    const {
        loading: useUpdateDocumentsClausesLoading,
        request: useUpdateDocumentsClausesRequest,
    } = useUpdateDocumentsClausesSync(idOperation || match.params.idOperation);

    const {
        data: useGetDocumentsParamsData,
        loading: useGetDocumentsParamsLoading,
        error: useGetDocumentsParamsError,
        status: useGetDocumentsParamsStatus,
        request: useGetDocumentsParamsRequest,
    } = useGetDocumentsParams();

    const {
        loading: useLostOperationLoading,
        status: useLostOperationStatus,
        request: useLostOperationRequest,
    } = useLostOperation(idOperation || match.params.idOperation);

    const {
        data: useCompareQuestionnairesByIdOperationSyncData,
        loading: useCompareQuestionnairesByIdOperationSyncLoading,
        error: useCompareQuestionnairesByIdOperationSyncError,
        status: useCompareQuestionnairesByIdOperationSyncStatus,
        request: useCompareQuestionnairesByIdOperationSyncRequest,
    } = useCompareQuestionnairesByIdOperationSync(
        operation?.isRenewal ?
            operation.operationParent.idOperationRoot :
            operation?.idOperationParent || operation?.idOperation
    );

    const {
        data: getQuestionnaireData,
        loading: getQuestionnaireLoading,
        error: getQuestionnaireError,
        status: getQuestionnaireStatus,
        request: getQuestionnaireRequest,
    } = useGetQuestionnairesByIdProduct(match.params.idProduct || idOperation);

    const {
        data: useGetQuestionnairesAnswersData,
        loading: useGetQuestionnairesAnswersLoading,
        error: useGetQuestionnairesAnswersError,
        status: useGetQuestionnairesAnswersStatus,
        request: useGetQuestionnairesAnswersRequest,
    } = useGetQuestionnaireAnswer(idOperation || refOperation);

    const {
        data: useGetInterpolationLimitsData,
        loading: useGetInterpolationLimitsLoading,
        error: useGetInterpolationLimitsError,
        status: useGetInterpolationLimitsStatus,
        request: useGetInterpolationLimitsRequest,
    } = useGetInterpolationLimits(idOperation || match.params.idOperation);

    const {
        data: useSaveOperationsData,
        loading: useSaveOperationsLoading,
        error: useSaveOperationsError,
        status: useSaveOperationsStatus,
        request: useSaveOperationsRequest,
    } = useSaveOperations();


    const {
        loading: useGetOperationLoading,
        request: useGetOperationRequest
    } = useGetOperationAsync(idOperation || match.params.idOperation);

    const {
        loading: useUpdateOperationLoading,
        request: useUpdateOperationRequest
    } = useUpdateOperationSync(idOperation);

    const {
        data: useVerifyRiskAcceptanceData,
        loading: useVerifyRiskAcceptanceLoading,
        error: useVerifyRiskAcceptanceError,
        status: useVerifyRiskAcceptanceStatus,
        request: useVerifyRiskAcceptanceRequest
    } = useVerifyRiskAcceptance(idOperation);

    const {
        loading: useGetCommercialPlansByIdOperationLoading,
        request: useGetCommercialPlansByIdOperationRequest
    } = useGetCommercialPlansByIdOperationSync(idOperation || match.params.idOperation);

    const {
        loading: useCalculateLoading,
        request: useCalculateRequest
    } = useCalculateSync(idOperation || match.params.idOperation);

    const {
        loading: useMaxLimClaimLoading,
        request: useMaxLimClaimRequest
    } = useMaxLimClaim(idOperation || match.params.idOperation);

    const {
        data: useResetOperationStateData,
        loading: useResetOperationStateLoading,
        error: useResetOperationStateError,
        status: useResetOperationStateStatus,
        request: useResetOperationStateRequest,
    } = useResetOperationState(idOperation);

    const {
        request: getPersonRequest,
    } = useGetPersonsSync();

    const {
        data: useGenerateQuoteData,
        loading: useGenerateQuoteLoading,
        error: useGenerateQuoteError,
        status: useGenerateQuoteStatus,
        request: useGenerateQuoteRequest
    } = useGenerateQuoteASync(idOperation || match.params.idOperation);

    const {
        data: useCreateQuoteOperationData,
        loading: useCreateQuoteOperationLoading,
        error: useCreateQuoteOperationError,
        status: useCreateQuoteOperationStatus,
        request: useCreateQuoteOperationRequest
    } = useCreateQuoteOperation();

    const {
        data: useUpdateQuoteOperationData,
        loading: useUpdateQuoteOperationLoading,
        error: useUpdateQuoteOperationError,
        status: useUpdateQuoteOperationStatus,
        request: useUpdateQuoteOperationRequest
    } = useUpdateQuoteOperation();

    const {
        loading: useGetDatajudProcessInfoLoading,
        request: useGetDatajudProcessInfoRequest
    } = useGetDatajudProcessInfo();

    const {
        loading: useGetMonetaryCorrectionAsyncLoading,
        request: useGetMonetaryCorrectionAsyncRequest
    } = useGetMonetaryCorrectionAsync(idOperation);

    const {
        loading: useGetOperationsAsyncLoading,
        request: useGetOperationsAsyncRequest
    } = useGetOperationsAsync();

    const {
        loading: useCalculateCancellationSyncLoading,
        request: useCalculateCancellationSyncRequest
    } = useCalculateCancellationSync(idOperation);

    const {
        loading: useGetBorrowerByIdPersonLoading,
        request: useGetBorrowerByIdPersonRequest,
    } = useGetBorrowerByIdPerson();

    const {
        loading: useCheckConsumptionLoading,
        request: useCheckConsumptionRequest,
    } = useCheckConsumption(idOperation);

    const {
        request: useGetQueryRequest,
        loading: useGetQueryLoading,
    } = useGetQuery();

    const {
        request: useGetProductPlanVigencyParamsSyncRequest,
        loading: useGetProductPlanVigencyParamsSyncLoading,
    } = useGetProductPlanVigencyParamsSync();

    const {
        request: useGetBorrowerBrokerByIdOperationRequest,
    } = useGetBorrowerBrokerByIdOperation();

    const {
        request: useSaveOperationsAsyncRequest,
        loading: useSaveOperationsAsyncLoading,
    } = useSaveOperationsAsync();


    const requestBrokerList = async () => {
        const { data } = await useGetQueryRequest({
            id: 'fitQueryPersonBroker',
            params: {
                id: "fitQueryPersonBroker",
                queryTail: true,
                personName: ''
            }
        });

        try {
            if (data.ret_code !== 200) return;

            const persons = data.ret_value.map(person => ({
                ...person,
                label: person.personName,
                value: person.id
            }));

            setBrokerList(persons)
        } catch (err) {
            console.log("err fitQueryPersonBroker", err)
        };
    };

    const requestProductList = async () => {
        const { data } = await useGetQueryRequest({
            id: 'fitGetProductPerson',
            params: {
                id: "fitGetProductPerson"
            }
        });

        try {
            if (data.ret_code !== 200) return;

            const product = data.ret_value.find(v => +v.ID_PRODUCT === +match.params.idProduct);

            setProduct(product);
        } catch (err) {
            console.log("err fitGetProductPerson", err)
        };
    };

    const {
        loading: useGetDocumentsAsyncLoading,
        request: useGetDocumentsAsyncRequest,
    } = useGetDocumentsAsync(idOperation);

    useEffect(() => {
        if (!getQuestionnaire.current) {
            if (isEmpty(permissions)) return;

            if (refOperation) {
                useGetOperationRequest(null, null, null, `v2/operation/${refOperation}`).then(async response => {
                    await requestBrokerList();
                    await requestProductList();
                    let operationData;
                    if (response.status === 200) operationData = response.data?.value;

                    refOperationData.current = operationData;

                    useGetQuestionnairesAnswersRequest(null, {
                        idDomainStatus: 7,
                        idDomain: operationData?.idDomain,
                        // idProductPlan: operationData?.idProductPlan
                    });
                });
            } else if (match.params.idOperation) {
                useGetOperationRequest(null, { loadLastDocument: true, loadCreditAnalysis: true, loadOperationPersonRoles: true }).then(async response => {
                    await requestBrokerList();
                    await requestProductList();
                    let operationData;

                    if (response.status === 200) {
                        operationData = response.data?.value;

                        if (operationData.idDomain !== 26 || operationData?.isRenewal) {
                            let emissionOperation = null;
                            if (operationData.idDomain !== 26) {
                                const { data: operationsData } = await useGetOperationsAsyncRequest(
                                    null,
                                    {
                                        idDomain: [27],
                                        idOperationRoot: operationData.idOperationRoot
                                    }
                                );
                                emissionOperation = operationsData.value[0];
                            } else if (operationData?.isRenewal) {
                                const quoteIdOperation = operationData?.operationParent?.idOperationRoot;
                                const { data: { value: operation } } = await useGetOperationRequest(
                                    null,
                                    null,
                                    null,
                                    `v2/operation/${quoteIdOperation}`
                                );
                                emissionOperation = operation
                            }

                            if (emissionOperation) {
                                const { data: { value: [policyDocument] } } = await useGetDocumentsAsyncRequest(
                                    null,
                                    { idDomain: 25 },
                                    null,
                                    `v2/operation/${emissionOperation.idOperation}/documents`
                                );

                                if (policyDocument && policyDocument.idDomainStatus === 383) {
                                    const { policyInceptionDate, policyExpiryDate } = policyDocument?.documentMetadata || {};
                                    emissionDates.current.inceptionDate = policyInceptionDate;
                                    emissionDates.current.expiryDate = policyExpiryDate;
                                }
                            }
                        }

                        setOperation(operationData);
                        setIsAwaitingAnalysis(operationData?.idDomainStatus === 10 || operationData?.idDomainStatus === 2);
                        if (operationData.idDomain === 254 && !GENERATE_PERMISSION) {
                            //setIsAwaitingAnalysis(operationData?.idDomainStatus !== 178);
                            setIsAwaitingAnalysis(false);
                        }

                        if (operationData.idDomain === 400 && !GENERATE_PERMISSION) {
                            //setIsAwaitingAnalysis(![141, 447].includes(operationData?.idDomainStatus));
                            setIsAwaitingAnalysis(false);
                        }

                        if (operationData.idDomain === 398 && !GENERATE_PERMISSION) {
                            //setIsAwaitingAnalysis(![116, 448].includes(operationData?.idDomainStatus));
                            setIsAwaitingAnalysis(false);
                        }

                        setIsBound([5, 2, 6, 187, 188, 126, 133, 140, 151, 158, 159, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(operationData?.idDomainStatus))
                    }
                    if (back) {
                        useGetQuestionnairesAnswersRequest(null, {
                            idDomainStatus: operationData?.isRenewal ? 388 : 7,
                            idDomain: operationData?.isRenewal ? 607 : operationData?.idDomain,
                            // idProductPlan: operationData?.idProductPlan
                        })
                    } else {


                        useGetQuestionnairesAnswersRequest(null, {
                            idDomainStatus: operationData?.isRenewal ? 388 : operationData?.idDomainStatus,
                            idDomain: operationData?.isRenewal ? 607 : operationData?.idDomain,
                            // idProductPlan: operationData?.idProductPlan
                        })
                    }
                });
            } else {
                requestProductList().then(() => {
                    requestBrokerList().then(() => getQuestionnaireRequest(null, { idDomainStatus: 7 }))
                });
            }
            getQuestionnaire.current = true
        }
    }, [permissions]);

    useEffect(() => {
        if (getQuestionnaireStatus === 200 || useGetQuestionnairesAnswersStatus === 200) {
            const dataReference = getQuestionnaireData?.timestampLocal || useGetQuestionnairesAnswersData?.timestampLocal;
            handleQuestionnaire(getQuestionnaireData?.value || useGetQuestionnairesAnswersData?.value, dataReference);
            setSystemDateReference(dataReference);
            const { isEdit: isHistoryEdit } = history?.location?.state ?? {};
            setIsEdit(isHistoryEdit || [1, 7, 4, 116, 141, 178, 384, 443, 444, 445, 447, 448].includes(operation?.idDomainStatus) || !operation?.idDomainStatus);
        }
    }, [getQuestionnaireStatus, useGetQuestionnairesAnswersStatus]);

    useMemo(() => {
        if (useLostOperationStatus === 200) {
            return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
        }
    })

    useEffect(() => {
        if (invalidBrokers.length) {
            for (const broker of invalidBrokers) {
                mc.error(`${broker.idDomain === 10 ? 'Corretor' : 'Co-corretor'} ${broker.PERSON_LAST_NAME} sem código seguradora válido. Favor contatar a unidade.`);
            }
            setInvalidBrokers([]);
        }

        if (invalidCoInsurers.length) {
            for (const insurer of invalidCoInsurers) {
                mc.error(`Cosseguradora ${insurer.PERSON_LAST_NAME} sem código externo válido. Favor contatar a unidade.`);
            }
            setInvalidCoInsurers([]);
        }
    }, [invalidBrokers, invalidCoInsurers]);

    useEffect(() => {
        if (!useCreateQuoteOperationStatus) return;

        if (useCreateQuoteOperationStatus === 200) {
            setIdOperation(useCreateQuoteOperationData.value.idOperation);
        }

        if (useCreateQuoteOperationStatus === 400 || useCreateQuoteOperationStatus === 500) {
            useCreateQuoteOperationError.errors?.map(error => {
                if (error.message) mc.error(error.message)
            })
        }

    }, [useCreateQuoteOperationStatus]);

    useEffect(() => {
        const afterSavingQuestionnaireAnswer = async () => {
            if (operation?.isRenewal || [254, 398, 400].includes(operation?.idDomain)) {
                const operationMetadata = operation.operationMetadata;
                let updateMetadata = false;

                if (operation.operationMetadata?.unchangedRiskQuestionnaire) {
                    delete operationMetadata.unchangedRiskQuestionnaire;
                    updateMetadata = true;
                }

                if (updateMetadata) {
                    const { data: { value: operationData } } = await useUpdateOperationRequest({ operationMetadata });
                    setOperation(operationData);
                }
            }

            useGetQuestionnairesAnswersRequest(null, {
                idDomainStatus: operation?.isRenewal ? 7 : operation?.idDomainStatus,
                idDomain: operation?.isRenewal ? 607 : null,
                // idProductPlan: operation?.isRenewal ? operation?.idProductPlan : null
            })
            useVerifyRiskAcceptanceRequest(null, {
                draft: true
            });
        };

        if (useUpdateQuoteOperationStatus === 200 || useCreateQuoteOperationStatus === 200) {
            afterSavingQuestionnaireAnswer();
        }

        if (useUpdateQuoteOperationStatus === 400 || useUpdateQuoteOperationStatus === 500) {
            useUpdateQuoteOperationError.errors?.map(error => {
                if (error.message) mc.error(error.message);
            })
        }

    }, [useUpdateQuoteOperationStatus, idOperation]);

    useEffect(() => {
        const save = async () => {
            if (useVerifyRiskAcceptanceStatus === 200) {
                if (!goToNextPage.current) {
                    match.params.idOperation ? mc.success(`Operação ${idOperation} atualizada com sucesso`) : mc.success(`Operação ${idOperation} criada com sucesso`);
                    return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
                }
                const { riskDescription, riskQuestions } = useVerifyRiskAcceptanceData?.value;
                if (riskDescription === 'Declinar') {
                    let idDomainStatusParam;

                    if (operation?.idDomain === 254) {
                        idDomainStatusParam = 188;
                    } else if (operation?.idDomain === 398) {
                        idDomainStatusParam = 140;
                    } else {
                        idDomainStatusParam = 2;
                    }

                    useUpdateOperationRequest({ idDomainStatus: idDomainStatusParam }).then(() => {
                        mc.error('Prezado Corretor, Agradecemos a oportunidade de analisar a cotação. Contudo, devido aos critérios estabelecidos em nossa política de aceitação, o risco em questão não se enquadra em nossa política de aceitação vigente.  Agradecemos a compreensão e esperamos contar com novas oportunidades de negócio em breve');
                        return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
                    });

                    return
                }

                if (operation?.idDomain === 254 || operation?.idDomain === 400) {
                    if (!goToNextPage.current) {
                        mc.success(`Endosso ${idOperation} criado com sucesso`);
                        return history.push('/polices');
                    } else if (GENERATE_PERMISSION) {
                        if (operation?.idDomain === 400) {
                            await useUpdateOperationRequest({ idDomainStatus: 445 });
                            await useCalculateCancellationSyncRequest({
                                isProRata: true,
                                idProductPlanSelected: operation.idProductPlan,
                                questionMappingAdhoc: [
                                    {
                                        "mapName": "mapQuestion3534",
                                        "mapValue": 0
                                    },
                                ]
                            });
                            if (+match.params.idProduct === 9004) {
                                history.push(`/quote/plans-rcg/${match.params.idProduct}/${operation?.idOperation || idOperation}`)
                            } else {
                                history.push(`/quote/plans/${match.params.idProduct}/${operation?.idOperation || idOperation}`)
                            }
                            return;
                        }

                        await useRequestSompoGetInternalProcessNumberRequest({ idOperation: match.params.idOperation })
                            .then(async (e) => {
                                return await useGenerateQuoteRequest({ endorsementStatusQuote: true }).then(async (response) => {
                                    if (response.status === 200) {
                                        if (operation?.idDomain === 254) {
                                            await useUpdateOperationRequest({ idDomainStatus: 384 });
                                            return history.push(`/adjustments-and-corrections/${match.params.idOperation}`)
                                        }
                                    } else {
                                        mc.error('Ocorreu um erro durante a solicitação.');
                                    }
                                })
                            })
                            .catch((e) => {
                                return mc.error('Ocorreu um erro na requisição do sistema externo - Numero do Processo Interno');
                            })
                    } else {
                        if (operation?.idDomain === 254) {
                            await useUpdateOperationRequest({ idDomainStatus: 443 });
                        }

                        if (operation?.idDomain === 400) {
                            await useUpdateOperationRequest({ idDomainStatus: 445 });
                        }

                        mc.success(`Endosso ${idOperation} solicitado com sucesso`);
                        return history.push('/polices');
                    }

                    return;
                }

                if (riskDescription === 'Analisar') {
                    if (!goToNextPage.current) {
                        match.params.idOperation ? mc.success(`Operação ${idOperation} atualizada com sucesso`) : mc.success(`Operação ${idOperation} criada com sucesso`);
                        return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
                    }

                    if (![10, 444].includes(operation?.idDomainStatus)) {
                        if ((permissions && !GENERATE_PERMISSION)) {
                            const { status } = await useResetOperationStateRequest({ idDomainOrigin: 26 })

                            if (operation?.idDomain === 26) {
                                useUpdateOperationRequest({ idDomainStatus: 10 })
                            } else if (operation?.idDomain === 398) {
                                useUpdateOperationRequest({ idDomainStatus: 444 })
                            }

                            mc.success('Esta operação será enviada para análise do subscritor');
                            if (status === 200) return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
                        }
                    }
                }

                if (operation?.idDomainStatus === 1 && !goToNextPage.current) {
                    match.params.idOperation ? mc.success(`Cotação ${idOperation} atualizada com sucesso`) : mc.success(`Cotação ${idOperation} criada com sucesso`);
                    if (!back && !goToNextPage.current) return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
                }

                useGetCommercialPlansByIdOperationRequest().then(async (response) => {
                    const { status, data } = response;

                    if (status !== 200) return

                    if (!data.value.length) {
                        await useUpdateOperationRequest({ idDomainStatus: operation?.idDomain === 398 ? 140 : 2 })

                        mc.error('Prezado Corretor, Agradecemos a oportunidade de analisar a cotação. Contudo, devido aos critérios estabelecidos em nossa política de aceitação, o risco em questão não se enquadra em nossa política de aceitação vigente.  Agradecemos a compreensão e esperamos contar com novas oportunidades de negócio em breve');
                        return history.push(operation?.idDomain === 26 || !operation?.idDomain ? '/list' : '/polices');
                    }
                    try {
                        const { status: statusCalculate } = await useCalculateRequest(null, { disableOptionalCoverages: +match.params.idProduct === 68 });
                        if (statusCalculate !== 200) return
                        if (+match.params.idProduct === 9004) {
                            history.push(`/quote/plans-rcg/${match.params.idProduct}/${operation?.idOperation || idOperation}`)
                        } else {
                            history.push(`/quote/plans/${match.params.idProduct}/${operation?.idOperation || idOperation}`)
                        }
                    } catch (e) {
                        await useLostOperationRequest();
                        mc.error('Prezado Corretor, Agradecemos a oportunidade de analisar a cotação. Contudo, devido aos critérios estabelecidos em nossa política de aceitação, o risco em questão não se enquadra em nossa política de aceitação vigente.  Agradecemos a compreensão e esperamos contar com novas oportunidades de negócio em breve');
                    }
                });

            }
        }

        save();
    }, [useVerifyRiskAcceptanceStatus]);

    useEffect(() => {
        updateIsLoadingStatus(
            getQuestionnaireLoading ||
            useGetQuestionnairesAnswersLoading ||
            useSaveOperationsLoading ||
            useGetOperationLoading ||
            useUpdateOperationLoading ||
            useVerifyRiskAcceptanceLoading ||
            useGetCommercialPlansByIdOperationLoading ||
            useCalculateLoading ||
            useMaxLimClaimLoading ||
            useResetOperationStateLoading ||
            useGenerateQuoteLoading ||
            useGetDocumentsParamsLoading ||
            useGetDatajudProcessInfoLoading ||
            clausesLoading ||
            useUpdateDocumentsClausesLoading ||
            useCompareQuestionnairesByIdOperationSyncLoading ||
            useGetMonetaryCorrectionAsyncLoading ||
            useRequestSompoGetInternalProcessNumberLoading ||
            useGetOperationsAsyncLoading ||
            useCalculateCancellationSyncLoading ||
            useGetBorrowerByIdPersonLoading ||
            useCheckConsumptionLoading ||
            useGetDocumentsAsyncLoading ||
            useGetQueryLoading ||
            useGetProductPlanVigencyParamsSyncLoading ||
            useCreateQuoteOperationLoading ||
            useUpdateQuoteOperationLoading ||
            useLostOperationLoading ||
            useGetInterpolationLimitsLoading ||
            useSaveOperationsAsyncLoading
        )
    }, [
        getQuestionnaireLoading,
        useGetQuestionnairesAnswersLoading,
        useSaveOperationsLoading,
        useGetOperationLoading,
        useUpdateOperationLoading,
        useVerifyRiskAcceptanceLoading,
        useGetCommercialPlansByIdOperationLoading,
        useCalculateLoading,
        useMaxLimClaimLoading,
        useResetOperationStateLoading,
        useGenerateQuoteLoading,
        useGetDocumentsParamsLoading,
        useGetDatajudProcessInfoLoading,
        clausesLoading,
        useUpdateDocumentsClausesLoading,
        useCompareQuestionnairesByIdOperationSyncLoading,
        useGetMonetaryCorrectionAsyncLoading,
        useRequestSompoGetInternalProcessNumberLoading,
        useGetOperationsAsyncLoading,
        useCalculateCancellationSyncLoading,
        useGetBorrowerByIdPersonLoading,
        useCheckConsumptionLoading,
        useGetDocumentsAsyncLoading,
        useGetQueryLoading,
        useGetProductPlanVigencyParamsSyncLoading,
        useCreateQuoteOperationLoading,
        useUpdateQuoteOperationLoading,
        useLostOperationLoading,
        useGetInterpolationLimitsLoading,
        useSaveOperationsAsyncLoading
    ]);

    useEffect(() => {
        const selectedCoBrokers = coBrokerGroup.map(group => {
            const brokerQuestion = group.find(qst => qst.idQuestion === 3453);
            const answer = brokerQuestion?.answer ? JSON.parse(brokerQuestion.answer).id : null;
            return answer;
        }).filter(brokerId => brokerId !== null);

        const brokerQuestionAnswer = questionnaire.find(q => q.idQuestion === 3386)?.answer

        if (brokerQuestionAnswer) selectedCoBrokers.push(JSON.parse(brokerQuestionAnswer).id)

        setSelectedBrokers(selectedCoBrokers)
    }, [questionnaire, coBrokerGroup])

    useEffect(() => {
        const selectedCoInsurer = coInsurerGroup.map(group => {
            const coInsurerQuestion = group.find(qst => qst.idQuestion === 1575);
            const answer = coInsurerQuestion?.answer ? JSON.parse(coInsurerQuestion.answer).id : null;
            return answer;
        }).filter(brokerId => brokerId !== null);

        const coInsurersPercentage = coInsurerGroup.reduce((acc, group) => {
            const percentageQuestion = group.find(qst => qst.idQuestion === 1576);
            return acc + Number(percentageQuestion?.answer || 0);
        }, 0)

        setSelectedCoInsurersPercentage(coInsurersPercentage)

        const sompoInsurerPercentage = questionnaire.find(q => q.idQuestion === 1804)?.answer;

        if (sompoInsurerPercentage && Number(sompoInsurerPercentage) !== (100 - coInsurersPercentage)) {
            setQuestionnaire(questionnaire.map(q => {
                if (q.idQuestion === 1804) {
                    q.answer = 100 - coInsurersPercentage;
                }
                return q;
            }))
        }

        setSelectedCoInsurers(selectedCoInsurer)
    }, [questionnaire, coInsurerGroup])

    const handleQuestionnaire = async (data, dataRerefence) => {
        let questionnaire = [];
        setBeneficiary([]);
        setCoInsuredGroup([]);
        setCoInsurerGroup([]);
        setCoBrokerGroup([]);
        setCashCollateralGroup([]);
        setExternalEntityGroup([]);
        setPartners([]);
        setRiskGroup([]);
        setQuestionnaire(questionnaire);

        await new Promise(resolve => setTimeout(() => resolve(), 500))

        questionnaire = [
            ...data.persons,
            ...data.operations,
            //...data.payments,
            ...data.risks
        ];
        questionnaire = await handleQuestionsInitialAdjustments(
            questionnaire,
            setPeriodicityText,
            operation || refOperationData.current,
            permissions,
            authContext,
            useMaxLimClaimRequest,
            dataRerefence,
            refOperation,
            brokerList,
            emissionDates.current,
            vigencyParams.current,
            handleGetProductPlanVigencyParams,
            product,
            GENERATE_PERMISSION
        );

        if (!isBound) {
            const correctedAmountUpdatable = await isCorrectedAmountUpdatable(questionnaire);
            if (correctedAmountUpdatable) {
                questionnaire = correctedAmountUpdatable;
            }
        }

        if (!GENERATE_PERMISSION)
            questionnaire = questionnaire.filter(qst => ![1425, 1204, 1205, 1309].includes(qst.idQuestion));

        questionnaire = questionnaire.map((question, index) => {
            if (question.idQuestion === 1213) {
                question.answer = authContext?.login_response?.ret_value?.applicationPersonRoot
            }
            return question;
        });

        const isQuestions = questionnaire.filter(question => question.idQuestion === 682);
        if (!match.params.idOperation || isQuestions.length < 3) {
            //forçar duplicatas da questão
            questionnaire.map((question, index) => {
                if (question.idQuestion === 682) {
                    question.idAnswerOption = question.behaviorObject.defaultValue;
                    questionnaire.push({ ...question, key: getQuestionUniqueKey(question, index), idQuestionnaireAnswers: null });
                    questionnaire.push({ ...question, key: getQuestionUniqueKey(question, index), idQuestionnaireAnswers: null });
                }
            });
        } else if (isQuestions.length) {
            questionnaire = questionnaire.map((question, index) => {
                if (question.idQuestion === 682) {
                    return { ...question, key: getQuestionUniqueKey(question, index) }
                }
                return question;
            });
        }

        const isQuestionsCoverage = questionnaire.filter(question => question.idQuestion === 3434);

        if (isQuestionsCoverage.length < 3) {
            //forçar duplicatas da questão
            questionnaire.map((question, index) => {
                if (question.idQuestion === 3434) {
                    questionnaire.push({ ...question, key: getQuestionUniqueKey(question, index), idQuestionnaireAnswers: null });
                    questionnaire.push({ ...question, key: getQuestionUniqueKey(question, index), idQuestionnaireAnswers: null });
                }
            });
        } else if (isQuestionsCoverage.length) {
            // questionnaire = questionnaire.map((question, index) => {
            //     if (question.idQuestion === 1250) {
            //         return { ...question, key: getQuestionUniqueKey(question, index) }
            //     }
            //     return question;
            // });
        }

        const typeOfApplicationQuestion = questionnaire.find(question => [3403].includes(question.idQuestion));
        if (typeOfApplicationQuestion) {
            let modalityPlans = [];

            // Se há uma resposta (array JSON), extrair os resultProductPlan de cada modalidade selecionada
            if (typeOfApplicationQuestion.answer) {
                try {
                    const selectedModalities = Array.isArray(typeOfApplicationQuestion.answer)
                        ? typeOfApplicationQuestion.answer
                        : JSON.parse(typeOfApplicationQuestion.answer);
                    modalityPlans = selectedModalities
                        .map(modality => {
                            const answerOption = typeOfApplicationQuestion.answerOptions.find(
                                opt => opt.idAnswerOption === modality.idAnswerOption
                            );
                            return answerOption?.behaviorObject?.resultProductPlan;
                        })
                        .filter(plan => plan !== undefined && plan !== null);
                } catch (error) {
                    console.error('Erro ao processar múltiplas modalidades:', error);
                }
            } else {
                // Fallback para modalidade única (compatibilidade com formato antigo)
                typeOfApplicationQuestion.idAnswerOption = typeOfApplicationQuestion?.idAnswerOption || typeOfApplicationQuestion?.behaviorObject?.defaultValue;
                const answerOption = typeOfApplicationQuestion?.idAnswerOption
                    ? typeOfApplicationQuestion.answerOptions.find(answerOption => answerOption.idAnswerOption === typeOfApplicationQuestion.idAnswerOption)
                    : typeOfApplicationQuestion.answerOptions.find(answerOption => answerOption.idAnswerOption === typeOfApplicationQuestion.behaviorObject.defaultValue);
                const { resultProductPlan } = answerOption?.behaviorObject || {};
                if (resultProductPlan) {
                    modalityPlans = [resultProductPlan];
                }
            }

            setCurrentModality(modalityPlans);
        }
        questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

        const arrBeneficiary = groupMultipleFieldQuestions(1587, questionnaire, operation, isBound);
        const arrCoInsured = groupMultipleFieldQuestions(3387, questionnaire, operation, isBound);
        const arrCoInsurerGroup = groupMultipleFieldQuestions(1575, questionnaire, operation, isBound);
        const arrCoBrokerGroup = groupMultipleFieldQuestions(3453, questionnaire, operation, isBound);
        const arrRiskGroup = groupMultipleFieldQuestions(3439, questionnaire, operation, isBound);

        setBeneficiary(arrBeneficiary);
        setCoInsuredGroup(arrCoInsured);
        setCoInsurerGroup(arrCoInsurerGroup);
        setCoBrokerGroup(arrCoBrokerGroup);
        setRiskGroup(arrRiskGroup);

        setCashCollateralGroup(groupMultipleFieldQuestions(1564, questionnaire, operation, isBound))

        setExternalEntityGroup(groupMultipleFieldQuestions(663, questionnaire, operation, isBound))
        setPartners(groupMultipleFieldQuestions(1190, questionnaire, operation, isBound))

        setQuestionnaire(questionnaire);
        if (hasSubscribeRatingAnswer == null) setHasSubscribeRatingAnswer(questionnaire.find(q => q.idQuestion == 1425)?.idAnswerOption === 6129);

        const hasAttachments = !!questionnaire.find(q => q.idQuestion == 694)?.answer
        setAttachmentsIsVisible(hasAttachments || [10, 4, 447, 448].includes(operation?.idDomainStatus));

        setCoInsuredNumber(arrCoInsured.length);
        setBeneficiaryNumber(arrBeneficiary.length);
        setCoBrokerNumber(arrCoBrokerGroup.length);
        setCoInsurerNumber(arrCoInsurerGroup.length);
    }

    useEffect(() => {
        if (cashCollateralGroup.length > 0) {
            let cashCollateralGroupAux = cashCollateralGroup;
            let questionValueContract = questionnaire.find(item => item.idQuestion == 1559)
            if (questionValueContract?.answer) {
                cashCollateralGroupAux.map(item => {
                    item.map(subitem => {
                        if (subitem.idQuestion == 1565) {
                            subitem.fieldMask.max = parseFloat(questionValueContract?.answer)
                        }
                    })
                })
            }
            setCashCollateralGroup(cashCollateralGroupAux)
        }
    }, [questionnaire])

    const validateRiskLocations = (questionnaire) => {
      const returnValue = {
        activityToBeSelectedDescription: [],
        error: false
      }

      if (riskGroup.length === 0) return returnValue;
      
      const mainActivityQuestion = questionnaire.find(q => [3403].includes(q.idQuestion));
      
      // Parse seguro da resposta da atividade principal
      let mainActivityAnswers;
      try {
        if (typeof mainActivityQuestion?.answer === 'string') {
          mainActivityAnswers = JSON.parse(mainActivityQuestion.answer);
        } else {
          mainActivityAnswers = mainActivityQuestion?.answer;
        }
      } catch (e) {
        mainActivityAnswers = null;
      }

      // Normalizar para array vazio se for falsy
      if (!Array.isArray(mainActivityAnswers)) {
        mainActivityAnswers = [];
      }
      
      // Pegar os idAnswerOption das atividades principais selecionadas
      const mainActivityIds = mainActivityAnswers.map(answer => answer.idAnswerOption).filter(Boolean);

      const riskGroupFiltered = riskGroup.map((group) => group.find(q => q.idQuestion === 3468)).filter(Boolean);

      for (const activeQuestion of riskGroupFiltered) {
        // Parse seguro da resposta
        let activityOptions;
        try {
          if (typeof activeQuestion?.answer === 'string') {
            activityOptions = JSON.parse(activeQuestion.answer);
          } else {
            activityOptions = activeQuestion?.answer;
          }
        } catch (e) {
          activityOptions = null;
        }

        // Normalizar para array vazio se for falsy
        if (!activityOptions) {
          activityOptions = [];
        }
        
        const selectedOptions = Array.isArray(activityOptions) 
          ? activityOptions.map(option => option.idAnswerOption || option) 
          : [activityOptions.idAnswerOption || activityOptions].filter(Boolean);

        // Verificar se cada atividade do local de risco tem correspondente na atividade principal
        for (const riskOptionId of selectedOptions) {
          const requiredMainActivityId = RISK_TO_MAIN_ACTIVITY_MAPPING[riskOptionId];
          
          // Se existe mapeamento e a atividade principal não está selecionada
          if (requiredMainActivityId && !mainActivityIds.includes(requiredMainActivityId)) {
            returnValue.error = true;
            
            // Pegar a descrição da atividade do local de risco para o erro
            const riskOption = activeQuestion.answerOptions.find(opt => opt.idAnswerOption === riskOptionId);
            const riskDescription = riskOption ? riskOption.dsAnswerOption : null;
            
            if (riskDescription && !returnValue.activityToBeSelectedDescription.includes(riskDescription)) {
              returnValue.activityToBeSelectedDescription.push(riskDescription);
            }
          } 
          // Se não existe mapeamento, opção é ignorada (pode ser válida sem validação)
          // Para debug, descomente a linha abaixo:
          // else if (!requiredMainActivityId) console.warn(`Atividade ${riskOptionId} não tem mapeamento definido`);
        }
      }
      
      return returnValue;
    }

    const buildValidation = (draft) => {
        const validationSchema = {};

        const questionnaire = handleSaveQuestionnaireAnswer(match.params.idOperation, true);
        for (const question of questionnaire) {
            if (draft && ![3400, 3403, 1518, 1519, 3386].includes(question.idQuestion)) continue;
            if ([614].includes(question.idDomainQuestion)) continue;
            if (!question.key) continue;
            if (
                currentModality.length > 0 &&
                question.productPlans &&
                question.productPlans.length &&
                !question.productPlans.some(plan => currentModality.includes(plan))
            ) continue;

            if ([3438].includes(question.idQuestion) && question.visibleQuestion) continue;

            question.childrenQuestions.map(item => {
                if (!item.key) return;
                if (
                    currentModality.length > 0 &&
                    item.productPlans &&
                    item.productPlans.length &&
                    !item.productPlans.some(plan => currentModality.includes(plan))
                ) return;

                if (item.visibleQuestion && item.fieldMask?.type == 'phone') {
                    if (item.behaviorObject?.isRequired || item.answer) {
                        if (item.idQuestion != 1522) {
                            validationSchema[item.key] = yup.string().test({
                                name: "answer-validation",
                                message: "Telefone inválido",
                                test: (value) => !!value && value.length >= 10
                            })
                        }
                    }
                } else if (item.visibleQuestion && item.behaviorObject?.fieldMask == 'email') {
                    if (item.answer) {
                        validationSchema[item.key] = yup.string().test({
                            name: "email-validation",
                            message: "E-mail inválido",
                            test: (value) => !invalidEmails.includes(item.answer)
                        }).email("E-mail inválido").required("Campo obrigatório");
                    } else {
                        if (item.behaviorObject?.isRequired) {
                            validationSchema[item.key] = yup.string().test({
                                name: "email-validation",
                                message: "E-mail inválido",
                                test: (value) => !invalidEmails.includes(item.answer)
                            }).email("E-mail inválido").required("Campo obrigatório");
                        } else {
                            validationSchema[item.key] = yup.string().notRequired();
                        }
                    }
                } else {
                    validationSchema[item.key] = item.visibleQuestion && item.behaviorObject?.isRequired
                        ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
                            return !!item.answer;
                        }) : yup.string().notRequired();
                }
            })

            if (question.visibleQuestion && question.fieldMask?.type == 'phone') {
                if (question.behaviorObject?.isRequired || question.answer) {
                    validationSchema[question.key] = yup.string().test({
                        name: "answer-validation",
                        message: "Telefone inválido",
                        test: (value) => !!value && value.length >= 10
                    })
                }
            } else if (question.visibleQuestion && question.behaviorObject?.fieldMask == 'email') {
                if (question.answer) {
                    validationSchema[question.key] = yup.string().test({
                        name: "email-validation",
                        message: "E-mail inválido",
                        test: (value) => !invalidEmails.includes(question.answer)
                    }).email("E-mail inválido").required("Campo obrigatório");
                } else {
                    if (question.behaviorObject?.isRequired) {
                        validationSchema[question.key] = yup.string().test({
                            name: "email-validation",
                            message: "E-mail inválido",
                            test: (value) => !invalidEmails.includes(question.answer)
                        }).email("E-mail inválido").required("Campo obrigatório");
                    } else {
                        validationSchema[question.key] = yup.string().notRequired();
                    }
                }
            } else {
                validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
                    ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
                        return !!question.answer;
                    }) : yup.string().notRequired();
            }

            if (question.idQuestion === 1555 && question.answer) {
                const endDate = new Date(questionnaire.find(item => item.idQuestion == 1556)?.answer);

                if (endDate) {
                    const startDate = new Date(question.answer);
                    validationSchema[question.key] = yup.string().test({
                        name: "vigência",
                        message: "Início de vigência não pode ser maior que o final de vigência",
                        test: () => moment(startDate).isSameOrBefore(endDate)
                    });
                }
            }

            if (question.idQuestion === 1556 && question.answer) {
                const startDate = questionnaire.find(item => item.idQuestion == 1555)?.answer;

                if (startDate) {
                    const endDate = new Date(question.answer);
                    const maxEndDate = new Date(new Date(startDate).setFullYear(new Date(startDate).getFullYear() + 10));
                    validationSchema[question.key] = yup.string().test({
                        name: "vigência",
                        message: "Fim de vigência não pode ser maior que 10 anos a partir do início de vigência",
                        test: () => moment(endDate).isSameOrBefore(maxEndDate)
                    });
                }
            }

            if (question.idQuestion === 1559 && question.answer) {
                validationSchema[question.key] = yup.string().test({
                    name: "answer-validation",
                    message: "O valor do contrato não pode ser menor que a Importância Segurada",
                    test: (value) => Number(value) >= Number(questionnaire.find(item => item.idQuestion == 1729)?.answer)
                })
            }

            if (question.idQuestion === 3403) {
                const { error, activityToBeSelectedDescription } = validateRiskLocations(questionnaire);

                if (error) {
                  const activityToBeSelectedDescriptionString = activityToBeSelectedDescription.join('; ');
                    // Adiciona validação na própria questão 3403
                    validationSchema[question.key] = yup.string().test({
                        name: "answer-validation",
                        message: `Selecione a(s) seguinte(s) atividade(s) do local de risco na atividade principal para prosseguir: ${activityToBeSelectedDescriptionString}`,
                        test: () => false
                    });
                }
            }
        }

        console.log("validationSchema:", validationSchema);
        return yup.object().shape(validationSchema);
    }

    const handleValidationsSubmittedForm = async (draft) => {
        const isEndorsement = [254, 398, 400].includes(operation?.idDomain);
        const isCancellationOrAdjustmentsAndCorrections = [254, 398, 400].includes(operation?.idDomain);

        const endorsementNotPreAgreedType = questionnaire.find(
            qst => qst.idQuestion === 3530
        )?.idAnswerOption;

        const modalityQst = questionnaire.find(qst => [3403].includes(qst.idQuestion));

        // const borrowerQstAnswer = questionnaire.find(qst => [1518, 1392].includes(qst.idQuestion))?.answer;
        // const borrowerPersonId = JSON.parse(borrowerQstAnswer || null)?.id;
        // if (borrowerPersonId && (!isEndorsement || [9034, 9035, 8169].includes(endorsementNotPreAgreedType))) {
        //     const canConsumeLimit = await handleCheckConsumption({ idPerson: borrowerPersonId });
        //     if (!canConsumeLimit) return false;
        // }

        // Verificar se alguma das modalidades selecionadas é do tipo Recursal (7118)
        let isRecursalModality = false;
        if (modalityQst?.answer) {
            try {
                const selectedModalities = Array.isArray(modalityQst.answer)
                    ? modalityQst.answer
                    : JSON.parse(modalityQst.answer);
                isRecursalModality = selectedModalities.some(modality => modality.idAnswerOption === 7118);
            } catch (error) {
                // Fallback para formato antigo
                isRecursalModality = modalityQst?.idAnswerOption === 7118;
            }
        } else {
            isRecursalModality = modalityQst?.idAnswerOption === 7118;
        }

        if (isRecursalModality) {//Recursal
            const currentISQst = questionnaire.find(
                qst => [1627].includes(qst.idQuestion) && qst.answer
            );
            if (currentISQst && !isCancellationOrAdjustmentsAndCorrections) {
                const coverageMaxLimClaimValue = await handleGetCoverageMaxLimClaim({
                    questionnaire,
                    useMaxLimClaimRequest,
                    mc
                });

                if (!isNumber(coverageMaxLimClaimValue)) {
                    return false;
                }

                if (+currentISQst.answer > +coverageMaxLimClaimValue) {
                    formikRef.current?.setFieldError(
                        currentISQst.key,
                        'Valor da IS maior que IS Máxima permitida'
                    );
                    mc.error(
                        `O valor da ${currentISQst.dsQuestion} não pode ultrapassar o valor da IS Máxima dessa modalidade`
                    );

                    return false;
                }
            }
        }

        if (draft) return true;
        const hasCoBrokers = sectionIsVisible("CO_BROKERS", coBrokerGroup[0], permissions, currentModality, true);
        const hasCoBrokerQst = questionnaire.find(
            qst => qst.idQuestion === 3452
        )?.idAnswerOption === 8984;

        let validationResult = true;

        if (operation?.idDomain !== 26) {
            const originalIS = Number(questionnaire.find(qst => qst.idQuestion === 3532)?.answer);

            const currentIS = questionnaire.find(
                qst => [3434].includes(qst.idQuestion) && qst.answer
            );
            const correctedIS = questionnaire.find(qst => qst.idQuestion === 1853);

            if (currentIS && +currentIS?.answer <= originalIS && endorsementNotPreAgreedType === 9034) {
                validationResult = false;
                formikRef.current?.setFieldError(
                    currentIS.key,
                    'Para endosso com movimento (aumento de IS), o valor da IS deve ser maior que o valor da IS da emissão anterior'
                );
                mc.error('Para o endosso com movimento (aumento de IS), é necessario aumentar o valor da IS em relação a emissão anterior.');
            } else if (currentIS && +currentIS?.answer >= originalIS && endorsementNotPreAgreedType === 9037) {
                validationResult = false;
                formikRef.current?.setFieldError(
                    currentIS.key,
                    'Para endosso com movimento (redução de IS), o valor da IS deve ser menor que o valor da IS da emissão anterior'
                );
                mc.error('Para o endosso com movimento (redução de IS), é necessario reduzir o valor da IS em relação a emissão anterior.');
            } else if ((!correctedIS || +correctedIS?.answer <= originalIS) && endorsementNotPreAgreedType === 8169) {
                validationResult = false;
                const msgField = !correctedIS ? 'A IS não teve correção monetária' : 'IS corrigida menor ou igual a IS origem';
                const msgToast = (
                    !correctedIS ?
                        'Para o endosso de aniversário, é obrigatório haver a correção monetária da IS.' :
                        'Para o endosso de aniversário a IS corrigida não pode ser menor ou igual a IS origem.'
                );
                formikRef.current?.setFieldError(
                    currentIS.key,
                    msgField
                );
                mc.error(msgToast);
            }
        }

        if (hasCoBrokerQst && hasCoBrokers) {
            const participationCoBrokers = coBrokerGroup.map(
                group => (group.find(qst => qst.idQuestion === 3454))
            );

            const totalParticipation = participationCoBrokers.reduce((accumulator, currentValue) => {
                return accumulator + parseFloat(currentValue.answer || 0);
            }, 0);

            if (totalParticipation > 99) {
                validationResult = false;
                for (const qst of participationCoBrokers) {
                    formikRef.current?.setFieldError(
                        qst.key,
                        'Participação deve totalizar no máximo 99%'
                    );
                }
                mc.error('A participação dos co-corretores deve totalizar no máximo 99%!');
            }
        }

        const startTermDate = questionnaire.find(qst => qst.idQuestion === 3447);
        const endTermDate = questionnaire.find(qst => qst.idQuestion === 3448);
        const endorsementEffectiveDate = questionnaire.find(qst => qst.idQuestion === 3495);

        if (endorsementEffectiveDate?.answer && endorsementNotPreAgreedType !== 9035) {
            const isBeforeDate = moment(
                new Date(endorsementEffectiveDate.answer)
            ).isBefore(new Date(startTermDate.answer));
            const isAfterDate = moment(
                new Date(endorsementEffectiveDate.answer)
            ).isAfter(moment(endTermDate.answer).subtract(1, 'days'));

            if (isBeforeDate) {
                formikRef.current?.setFieldError(
                    endorsementEffectiveDate.key,
                    'A data deve ser maior ou igual a da início de vigência'
                );
                mc.error('A data Início de Vigência do Endosso deve ser maior ou igual a da Início de Vigência');
                validationResult = false;
            }

            if (isAfterDate) {
                formikRef.current?.setFieldError(
                    endorsementEffectiveDate.key,
                    'A data deve ser de até um dia antes do fim de vigência da apólice'
                );
                mc.error('A data Início de Vigência do Endosso deve ser de até um dia antes do Fim de Vigência da apólice');
                validationResult = false;
            }
        }

        const startContractTermDate = questionnaire.find(qst => qst.idQuestion === 1555);
        const endContractTermDate = questionnaire.find(qst => qst.idQuestion === 1556);
        if (
            startTermDate?.answer &&
            startContractTermDate?.answer &&
            endContractTermDate?.answer &&
            !isEndorsement
        ) {
            const isBeforeStartContractLimitDate = moment(
                new Date(startContractTermDate.answer)
            ).isBefore(new Date(startTermDate.answer));

            const isBeforeEndContractLimitDate = moment(
                new Date(endContractTermDate.answer)
            ).isBefore(new Date(startTermDate.answer));

            if (isBeforeStartContractLimitDate || isBeforeEndContractLimitDate) {
                validationResult = false;
                formikRef.current?.setFieldError(
                    startContractTermDate.key,
                    'A data do contrato deve ser maior que a de vigência'
                );
                formikRef.current?.setFieldError(
                    endContractTermDate.key,
                    'A data do contrato deve ser maior que a de vigência'
                );
                mc.error(
                    'A data de inicio de contrato deve ser maior que a de vigência, por favor reinsira a data de inicio e fim de contrato de contrato'
                );
            }
        }

        const attachments = questionnaire.find(qst => qst.idQuestion === 1577);
        const requiredRenewalAttachments = questionnaire.find(qst => qst.idQuestion === 1857);
        if (
            attachments &&
            requiredRenewalAttachments?.idAnswerOption === 7472 &&
            Array.isArray(attachments.answer)
        ) {
            const renewalDoc = attachments.answer.find(doc => +doc?.documentType?.idAnswerOption === 7474);
            if (!renewalDoc) {
                validationResult = false;
                mc.error('Você está realizando uma renovação, por favor anexe os documentos correspondentes (Documentos de Renovação)');
            }
        }

        const endorsementExpiryDate = questionnaire.find(qst => qst.idQuestion === 3499);
        if (endTermDate?.answer || endorsementExpiryDate?.answer) {
            const endorsementChangingPeriod =
                [9035, 9036].includes(endorsementNotPreAgreedType) &&
                operation?.idDomain === 398;

            const questionKey = endorsementChangingPeriod ? endorsementExpiryDate.key : endTermDate.key;
            const expiryDate = endorsementChangingPeriod ? endorsementExpiryDate.answer : endTermDate.answer;

            if (moment(expiryDate).isBefore(new Date(systemDateReference), 'day')) {
                validationResult = false;
                formikRef.current?.setFieldError(
                    questionKey,
                    'Fim de vigência menor que a data de hoje'
                );
                mc.error(
                    'A data fim de vigência deve ser maior ou igual a data de hoje'
                );
            }
        }

        if (operation?.isRenewal) {
            const currentIS = questionnaire.find(
                qst => [1627, 1729].includes(qst.idQuestion) && qst.answer
            );
            const correctedIS = questionnaire.find(
                qst => qst.idQuestion === 1853
            )?.answer;
            const notEditRiskOnRenewal = questionnaire.find(
                qst => qst.idQuestion === 1854
            )?.idAnswerOption === 7467;

            if (!correctedIS && notEditRiskOnRenewal) {
                validationResult = false;
                formikRef.current?.setFieldError(
                    currentIS?.key,
                    'A IS não teve correção monetária'
                );
                mc.error(monetaryCorrectionErrorMsg.current);
            }
        }

        const brokerQuestion = questionnaire.find(qst => qst.idQuestion === 3386);

        // if (idOperation && +match.params.idProduct !== 9004) {
        //     const { data: { value: borrowerBroker } } = await useGetBorrowerBrokerByIdOperationRequest(null, { idOperation });

        //     if (borrowerBroker.idPerson != JSON.parse(brokerQuestion.answer || '{}')?.id) {
        //         validationResult = false;
        //         formikRef.current?.setFieldError(
        //             brokerQuestion.key,
        //             'Esse corretor não tem nomeação para este Tomador'
        //         );
        //         mc.error('Esse corretor não tem nomeação para este Tomador');

        //         const elements = global.window.document.getElementsByName(brokerQuestion.key);
        //         if (elements?.length) {
        //             setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
        //         }
        //     }
        // }

        const qstSusepProcess = questionnaire.find(qst => qst.idQuestion === 3002);
        if (qstSusepProcess) {
            if (!qstSusepProcess?.answer) {
                validationResult = false;
                mc.error('O número do processo SUSEP não foi atribuido para a operação.');
            } else {
                const productMetadata = JSON.parse(product?.PRODUCT_METADATA || '{}');
                const processSusepVersions = productMetadata?.processSusepVersions || [];
                const processSusepNumber = processSusepVersions.find(
                    version => version.processSusepNumber === qstSusepProcess.answer
                )?.processSusepNumber;

                if (!processSusepNumber) {
                    validationResult = false;
                    mc.error('O número do processo SUSEP atribuido para a operação não é válido para o produto selecionado.');
                }
            }
        }

        // Validação específica para questions 3428, 3431 e 3470
        const question3431 = questionnaire.find(qst => qst.idQuestion === 3431);
        const question3428 = questionnaire.find(qst => qst.idQuestion === 3428);
        const question3470 = questionnaire.find(qst => qst.idQuestion === 3470);

        if (question3431?.idAnswerOption === 8975 && question3470?.answer) {
            const valorObra = parseFloat(question3428.answer?.replace(/[^\d,]/g, '')?.replace(',', '.')) || 0;
            const valorInputado = parseFloat(question3470.answer?.replace(/[^\d,]/g, '')?.replace(',', '.')) || 0;

            if (valorInputado > valorObra) {
                validationResult = false;
                formikRef.current?.setFieldError(
                    question3470.key,
                    `Não pode ser maior que o valor total da obra`
                );
                mc.error(`${question3470.dsQuestion} não pode ser maior o valor total da obra`);
            }
        }

        return validationResult;
    }

    const onSave = (values, idDomainStatus, draft) => {
        goToNextPage.current = idDomainStatus != null;

        buildValidation(draft).validate(values, { abortEarly: false }).then(async () => {
            const validationResult = await handleValidationsSubmittedForm(draft);
            if (validationResult) handleSubmit(values, idDomainStatus);
        }).catch((e) => {
            onValidationError(e, mc, formikRef, questionnaire, [...partners, ...externalEntityGroup, ...beneficiary, ...coInsuredGroup, ...riskGroup, ...cashCollateralGroup, ...coInsurerGroup])
        })
    }

    const isCorrectedAmountUpdatable = async (questionnaire) => {

        const endorsementNotPreAgreedType = questionnaire.find(
            qst => qst.idQuestion === 3530
        )?.idAnswerOption;
        const correctedIS = questionnaire.find(qst => qst.idQuestion === 1853)?.answer;

        const requiresMonetaryCorrection = (
            !correctedIS &&
            (
                operation?.isRenewal ||
                (operation?.idDomain === 398 && endorsementNotPreAgreedType === 8169)
            )
        );

        if (requiresMonetaryCorrection) {
            try {
                const { data: { value } } = await useGetMonetaryCorrectionAsyncRequest(null, {});

                questionnaire = questionnaire.map((question, index) => {
                    if (question.idQuestion === 1853) {
                        question.answer = value;
                        formikRef.current?.setFieldValue(question.key, value);
                    } else if (
                        [1627, 1729].includes(question.idQuestion) &&
                        question?.answer &&
                        value > +question?.answer
                    ) {
                        question.answer = value;
                        formikRef.current?.setFieldValue(question.key, value);
                    }
                    return question;
                });

                return questionnaire;
            } catch (e) {
                const msgError = 'Ocorreu um erro no calculo de atualização de IS - Tabela de Índices Desatualizada';
                monetaryCorrectionErrorMsg.current = msgError;
                mc.error(msgError);
            }

            return false;
        }
    };

    const handleSubmit = async (values, idDomainStatus) => {
        if (questionnaireSent.current) return;
        const valueIS = questionnaire.find(
            qst => [1627, 1729].includes(qst.idQuestion) && qst?.answer
        )?.answer || null;

        const qstModality = questionnaire.find(qst => [3403].includes(qst.idQuestion));

        // Buscar modalidades selecionadas
        let modality = null;
        if (qstModality?.answer) {
            try {
                const selectedModalities = Array.isArray(qstModality.answer)
                    ? qstModality.answer
                    : JSON.parse(qstModality.answer);
                if (selectedModalities.length > 0) {
                    const firstModality = selectedModalities[0];
                    const answerOption = qstModality.answerOptions.find(
                        opt => opt.idAnswerOption === firstModality.idAnswerOption
                    );
                    modality = answerOption?.behaviorObject?.resultProductPlan;
                }
            } catch (error) {
                console.error('Erro ao processar modalidades na validação:', error);
            }
        } else if (qstModality?.idAnswerOption) {
            // Fallback para formato antigo
            modality = qstModality?.answerOptions
                .find(answerOption => answerOption?.idAnswerOption === qstModality?.idAnswerOption)
                ?.behaviorObject?.resultProductPlan;
        }

        if (!match.params.idOperation && !idOperation) {
            return handleSaveQuestionnaireAnswer(null, false, null, valueIS, modality, idDomainStatus || 7);
        }

        if (idOperation || match.params.idOperation) {
            if (operation?.idDomainStatus === 7 && idDomainStatus === 1) {
                return handleSaveQuestionnaireAnswer(idOperation || match.params.idOperation, null, null, valueIS, modality, idDomainStatus);
            } else if (!idDomainStatus && (valueIS || modality)) {
                return handleSaveQuestionnaireAnswer(idOperation || match.params.idOperation, null, null, valueIS, modality);
            }

            return handleSaveQuestionnaireAnswer(idOperation || match.params.idOperation);
        }
    }

    const handleSaveQuestionnaireAnswer = (idOperation, onlyQuestions, formattedGroups, operationMaxLimClaim = null, idProductPlan = null, idDomainStatus = null) => {
        let questionnaireAnswers = cloneDeep(questionnaire);
        for (const [key, section] of Object.entries(SECTIONS)) {
            if (section.isMultiple) {
                let multipleFields = []
                switch (section.name) {
                    case 'BENEFICIARY':
                        multipleFields = cloneDeep(beneficiary);
                        break;
                    case 'EXTERNAL':
                        multipleFields = cloneDeep(externalEntityGroup);
                        break;
                    case 'CO_INSURED':
                        multipleFields = cloneDeep(coInsuredGroup);
                        break;
                    case 'PARTNER':
                        multipleFields = cloneDeep(partners);
                        break;
                    case 'CASH_COLLATERAL':
                        multipleFields = cloneDeep(cashCollateralGroup);
                        break;
                    case 'CO_INSURER':
                        multipleFields = cloneDeep(coInsurerGroup);
                        break;
                    case 'CO_BROKERS':
                        multipleFields = cloneDeep(coBrokerGroup);
                        break;
                    case 'RISK_LOCATION':
                        multipleFields = cloneDeep(riskGroup);
                        break;
                    default:
                        multipleFields = [];
                        break;
                }

                multipleFields.map(group => {
                    if (group?.length) {
                        const rootQuestion = group.find(question => !question.idQuestionRoot);
                        const childrenQuestions = group.filter(question => question.idQuestionRoot);
                        rootQuestion.childrenQuestions = childrenQuestions;
                        if (!onlyQuestions || formattedGroups) {
                            questionnaireAnswers = [...questionnaireAnswers, rootQuestion];
                        } else {
                            questionnaireAnswers = [...questionnaireAnswers, ...group];
                        }
                    }
                })
            }
        }

        let childrenQuestionIds = [];
        for (const question of questionnaireAnswers) {
            if (question) {
                if (
                    (
                        question.idDomainQuestion === 270 ||
                        question.idDomainQuestion === 271 ||
                        (question.idDomainQuestion === 44 && typeof question.answer === 'object')
                    ) && question.answer
                ) {
                    try {
                        question.answer = JSON.stringify(question.answer)
                    } catch (e) {
                    }
                }

                if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
                    if (question?.childrenQuestions?.length) {
                        const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
                        childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
                    }
                } else if (question.idQuestion !== 1250) {
                    question.childrenQuestions = [];
                }

                if (
                    currentModality.length > 0 &&
                    question.productPlans?.length &&
                    !question.productPlans.some(plan => currentModality.includes(plan)) &&
                    (question?.answer != null || question?.idAnswerOption)
                ) {
                    question.answer = null;
                    question.idAnswerOption = null;
                }
            }
        }

        questionnaireAnswers = questionnaireAnswers.filter(v =>
            !childrenQuestionIds.includes(v.idQuestion) &&
            v.idQuestion !== 1812
        );

        if (onlyQuestions) return questionnaireAnswers;

        const activityQuestion = questionnaireAnswers.find(q => q.idQuestion === 3403);
        let activityQuestionAnswer = activityQuestion?.answer;
        try {
            activityQuestionAnswer = JSON.parse(activityQuestionAnswer);
        } catch (e) {
            console.error('Erro ao converter resposta para string:', e);
        }

        for (const question of questionnaireAnswers) {
            if (question.idQuestion === 3439) {
                const riskLocationActivityQuestions = question.childrenQuestions.filter(q => q.idQuestion === 3468);
                for (const riskLocationActivityQuestion of riskLocationActivityQuestions) {
                    let answer = riskLocationActivityQuestion.answer;
                    if (answer) {
                        try {
                            answer = JSON.parse(answer);
                        } catch (e) {
                            console.error('Erro ao converter resposta para string:', e);
                        }
                    }

                    if ((!answer || !answer.length) && activityQuestionAnswer?.length) {
                        riskLocationActivityQuestion.answer = null

                        const rowOptions = activityQuestionAnswer.map(option => option.dsAnswerOption.toLowerCase().trim()).filter(option => option);
                        let foundQuestionOptions = riskLocationActivityQuestion.answerOptions.filter(v => rowOptions.includes(v.dsAnswerOption?.trim().toLowerCase()));
                        foundQuestionOptions = foundQuestionOptions.map(option => ({ idAnswerOption: option.idAnswerOption, dsAnswerOption: option.dsAnswerOption, resultValue: null }))

                        riskLocationActivityQuestion.answer = JSON.stringify(foundQuestionOptions);
                        riskLocationActivityQuestion.answerJson = null;
                    } else {
                        try {
                            riskLocationActivityQuestion.answer = JSON.stringify(answer);
                            riskLocationActivityQuestion.answerJson = null;
                        } catch (e) {
                            console.error('Erro ao converter resposta para string:', e);
                        }
                    }
                }
            }
        }

        const getInterpolationLimits = async () => {
            setForceLoading(true);

            let operationData = operation
            if (!operation?.idOperation && !idOperation) {
                const { data: { value: operationResponse } } = await useSaveOperationsAsyncRequest(
                    {
                        idDomain: 26,
                        idDomainStatus: idDomainStatus || 7,
                        idProduct: match.params.idProduct,
                        idPerson: authContext?.login_response?.ret_value?.idPerson
                    })

                idOperation = operationResponse.idOperation;
                operationData = operationResponse;
                setOperation(operationResponse);
                setIdOperation(operationResponse.idOperation);
                await new Promise(resolve => setTimeout(() => resolve(), 500));
            }

            for (const question of questionnaireAnswers) {
                if (![682, 1250].includes(question.idQuestion)) continue;

                const interpolationLimitsUpdated = await handleInterpolationQuestions(
                    question.answer,
                    question,
                    null,
                    questionnaireAnswers,
                    null,
                    operationData
                )

                if (interpolationLimitsUpdated) questionnaireAnswers = interpolationLimitsUpdated;
                await new Promise(resolve => setTimeout(() => resolve(), 500));
            }
        }

        const hasCoInsurer = questionnaireAnswers.find(question => question.idQuestion === 1804 && question.visibleQuestion);
        if (hasCoInsurer) {
            let total = 0;
            for (const question of questionnaireAnswers) {
                if (question.idQuestion === 1575) total += Number(question?.childrenQuestions.find(qs => qs.idQuestion === 1576)?.answer) || 0;
            }

            total = Number((total).toFixed(2));

            if (total > 100) return mc.error('A participação no cosseguro deve ser de 100% !');
        }

        if (riskGroup?.length < 1 || (riskGroup[0] && riskGroup[0][0] && !riskGroup[0][0]?.answer)) {
            return mc.error('Adicione no mínimo 1 local de risco!');
        } else if (riskGroup?.length > 10) {
            return mc.error('Máximo de 10 locais de risco permitidos, favor rever os locais de risco adicionados!');
        }

        getInterpolationLimits().then(() => {
            if (idOperation) {
                const historyQuestion = questionnaireAnswers.find(q => q.idQuestion === 3497);
                const descriptionOfChanges = questionnaireAnswers.find(q => q.idQuestion === 3498);
                let questionnaireAnswersChange = cloneDeep(questionnaireAnswers);

                const endorsementNotPreAgreedType = questionnaireAnswers.find(
                    qst => qst.idQuestion === 3530
                )?.idAnswerOption;

                if ((
                    ![9035, 9036].includes(endorsementNotPreAgreedType) ||
                    [254].includes(operation?.idDomain)
                )) {
                    questionnaireAnswersChange = questionnaireAnswersChange.map(qst => {
                        if ([3495, 3499].includes(qst.idQuestion)) {
                            delete qst.behaviorObject.compareWhenQuestionMissing
                        }
                        return qst;
                    });
                };

                let updateOperationBody = Object.fromEntries(
                    Object.entries({
                        idProduct: match.params.idProduct,
                        questionnaire: questionnaireAnswers,
                        idOperation,
                        idDomainStatus,
                        idProductPlan,
                        operationMaxLimClaim,
                        questionnaireAnswersToDelete
                    }).filter(([_, value]) => value)
                );

                if (historyQuestion) {
                    useCompareQuestionnairesByIdOperationSyncRequest(
                        {
                            replaceOperationChildrenQuestionnaire: questionnaireAnswersChange
                        },
                        {
                            idOperationChildren: idOperation,
                        }
                    ).then(response => {
                        const { data } = response;
                        if (data?.value?.sectionDiffAnswers?.length) {
                            const diffAnswer = data.value.sectionDiffAnswers.map(section => {
                                return ` 
                        ${section.questions.map(question => {
                                    if (!question.new?.visibleQuestion) return "";
                                    return `
                                <h3>${SECTIONS[question.previous.behaviorObject?.sectionName]?.fullName || ""}</h3>
                            <p>${question.previous.dsQuestion} <b>(Antes)</b>: ${question.previous.answer}</p>
                            <p>${question.new.dsQuestion} <b>(Depois)</b>: ${question.new.answer}</p>
                            `}).join(' ')}
                        `}).join('<br>')

                            historyQuestion.answer = diffAnswer

                            if (descriptionOfChanges) {
                                const questionIds = new Set();
                                questionnaireAnswers.forEach(qst => {
                                    if (qst.visibleQuestion) {
                                        questionIds.add(qst.idQuestion);
                                    }
                                    if (qst.childrenQuestions?.length) {
                                        qst.childrenQuestions.forEach(child => {
                                            if (child.visibleQuestion) {
                                                questionIds.add(child.idQuestion);
                                            }
                                        });
                                    }
                                });
                                
                                const idQuestionsFilteredArray = Array.from(questionIds);
                                const descriptionOfChangesAnswer = data?.value?.sectionDiffAnswers.map(section => {
                                    return !section.questions.some((question) => idQuestionsFilteredArray.includes(question.new.idQuestion))
                                        ? ''
                                        : ` 
                                <p style="margin-top: 10px;">
                                    Declara-se para os devidos fins e efeitos que a(s) seguinte(s) informação(ões) da presente Apólice foi(ram) alterada(s), passando a constar como:
                                </p>
                                <table class="visible-border" style="margin-top: 10px;">
                                <th class="visible-border" style="width: 25%;">
                                    Campo Alterado
                                </th>
                                <th style="width: 25%;">
                                    Seção
                                </th>
                                <th class="visible-border" style="width: 50%;">
                                    Alterado para:
                                </th>
                                ${section.questions.filter((question) => idQuestionsFilteredArray.includes(question.new.idQuestion)).map(question => {
                                            if (!question.new?.visibleQuestion) return "";
                                            return `
                                            <tr>
                                                <td class="visible-border">(${question.new.dsQuestion})</td> 
                                                <td class="visible-border">${SECTIONS[question.previous.behaviorObject?.sectionName]?.fullName}</td> 
                                                <td class="visible-border" style="word-break: break-word;">${question.new.answer}</td>
                                            </tr>
                                    `
                                        }).join(' ')}
                                    </table>
                                    <p style="margin-top: 10px;">Permanecem inalteradas as demais condições da Apólice.</p>
                                `;
                                }).join('')

                                descriptionOfChanges.answer = descriptionOfChangesAnswer;
                            }
                        }

                        if (selectedClauses?.length) {
                            useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 }).then(() => {
                                useUpdateQuoteOperationRequest(updateOperationBody, null, null, `v2/operation/quote/${idOperation}`)
                            })
                        } else {
                            useUpdateQuoteOperationRequest(updateOperationBody, null, null, `v2/operation/quote/${idOperation}`)
                        }
                    })
                } else {
                    if (selectedClauses?.length) {
                        useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 }).then(() => {
                            useUpdateQuoteOperationRequest(updateOperationBody, null, null, `v2/operation/quote/${idOperation}`)
                        })
                    } else {
                        useUpdateQuoteOperationRequest(updateOperationBody, null, null, `v2/operation/quote/${idOperation}`);
                    }
                }

            } else {
                useCreateQuoteOperationRequest({
                    idDomain: 26,
                    idDomainStatus: idDomainStatus,
                    idProduct: match.params.idProduct,
                    idPerson: authContext?.login_response?.ret_value?.idPerson,
                    questionnaire: questionnaireAnswers,
                    operationMaxLimClaim,
                    idProductPlan,
                    questionnaireAnswersToDelete
                })
            }
        })
    }

    const renderAddAndRemoveButtons = (array, index, questions, setFunction, partySectionName, ignoreRemove) => {
        let permissionLength = null;

        if (partySectionName === '$ANSWERS_CO_INSURED_0') {
            permissionLength = 4;
        } else if (partySectionName === '$ANSWERS_CO_INSURER_0') {
            permissionLength = 4;
        } else if (partySectionName === '$ANSWERS_CO_BROKERS_0') {
            permissionLength = 3;
        } else if (partySectionName === '$ANSWERS_RISK_LOCATION_0') {
            permissionLength = 10; // Limite de 10 locais de risco
        }
        return (
            <>
                {!ignoreRemove && index !== 0 ?
                    <AddButton style={{ marginBottom: '15px' }} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const newArray = array.filter((v, i) => i !== index);
                        setFunction(newArray);
                        setQuestionnaireAnswersToDelete([
                            ...questionnaireAnswersToDelete,
                            ...questions.map(
                                question => question.idQuestionnaireAnswers
                            ).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
                        ]);
                    }}>
                        <Icon name="trash" style={{ margin: 0 }} />
                    </AddButton> : <></>}
                {permissionLength && array.length === permissionLength ? <></> : index === array.length - 1 ?
                    <AddButton onClick={(e) => {
                        e.preventDefault(); e.stopPropagation();
                        setFunction([...array, removeAnswersDuplicateSession(questions)]);
                    }}>
                        <Icon name="plus" style={{ margin: 0 }} />
                    </AddButton> : <></>}
            </>
        )
    }

    const handleShowButtons = (disableAll, questions) => {
        return disableAll ||
            questions?.find(qst => !qst.visibleQuestion) ||
            (questions?.filter(qst => qst?.disabled || qst?.behaviorObject?.isReadOnly))?.length === questions?.length
    }

    const handleInterpolationQuestions = async (value, question, setFieldValue, filteredQuestionnaire, setFilteredQuestionnaire, operation) => {
        if (![682, 1250].includes(question.idQuestion)) return;

        if (String(value).includes(",")) {
            value = Number(String(value).replace('R$', '').replace(/\./g, '').replace(/,/g, '.').trim());
        }

        if (!operation?.idOperation) return;

        let idDomainDocument = null;
        const companyActivityQst = filteredQuestionnaire.find(qst => [3403].includes(qst.idQuestion));

        if (!companyActivityQst && +match.params.idProduct === 9004) return;

        if (companyActivityQst) {
            let resultIdDomainDocument = null;

            // Buscar modalidades selecionadas
            if (companyActivityQst?.answer) {
                try {
                    const selectedModalities = Array.isArray(companyActivityQst.answer)
                        ? companyActivityQst.answer
                        : JSON.parse(companyActivityQst.answer);
                    if (selectedModalities.length > 0) {
                        const firstModality = selectedModalities[0];
                        const answerOption = companyActivityQst.answerOptions.find(
                            opt => opt.idAnswerOption === firstModality.idAnswerOption
                        );
                        resultIdDomainDocument = answerOption?.behaviorObject?.resultIdDomainDocument;
                    }
                } catch (error) {
                    console.error('Erro ao processar modalidades:', error);
                }
            } else if (companyActivityQst?.idAnswerOption) {
                // Fallback para formato antigo
                resultIdDomainDocument = companyActivityQst.answerOptions.find(
                    opt => opt.idAnswerOption === companyActivityQst?.idAnswerOption
                )?.behaviorObject?.resultIdDomainDocument;
            }

            if (!resultIdDomainDocument) {
                resultIdDomainDocument = 1474;
            };
            idDomainDocument = resultIdDomainDocument;
        }

        if (value) {
            if (value < question.behaviorObject.fieldMinValue) {
                value = question.behaviorObject.fieldMinValue;
                question.answer = String(value);
            } else if (value > question.behaviorObject.fieldMaxValue) {
                value = question.behaviorObject.fieldMaxValue;
                question.answer = String(value);
            }
        }

        setForceLoading(true);

        const interpolationParams = [];
        if (+match.params.idProduct === 34) {
            interpolationParams.push({
                idQuestions: [675, 1173],
                idDomainDocument: 647,
                limit: value,
                optionalParams: [
                    {
                        name: 'mapQuestion675',
                        value: filteredQuestionnaire.find(qst => qst.idQuestion === 675)?.idAnswerOption || ''
                    },
                    {
                        name: 'mapQuestion1173',
                        value: filteredQuestionnaire.find(qst => qst.idQuestion === 1173)?.idAnswerOption || ''
                    }
                ]
            });
        } else if (+match.params.idProduct === 68) {
            if (idDomainDocument) {
                const params = {
                    idQuestions: [3277],
                    idDomainDocument: idDomainDocument,
                    limit: value,
                };

                interpolationParams.push(
                    {
                        ...params,
                        optionalParams: [
                            // {
                            //     name: 'deductibleType',
                            //     value: 'FN'
                            // },
                            {
                                name: 'mapQuestion3277',
                                value: filteredQuestionnaire.find(qst => qst.idQuestion === 3277)?.idAnswerOption || ''
                            }
                        ]
                    },
                    {
                        ...params,
                        optionalParams: [
                            // {
                            //     name: 'deductibleType',
                            //     value: 'FA'
                            // },
                            {
                                name: 'mapQuestion3277',
                                value: filteredQuestionnaire.find(qst => qst.idQuestion === 3277)?.idAnswerOption || ''
                            }
                        ]
                    }
                );
            }
        }

        for (const params of interpolationParams) {
            const response = await useGetInterpolationLimitsRequest(null, params, null, `/v2/questionnaire/${operation?.idOperation}/options/interpolation-limits`);

            if (response.status !== 200) {
                setTimeout(() => setForceLoading(false), 2000);
                return;
            }

            const { interpolationLimits, coverages } = response.data.value;

            if (question && value) {
                question.childrenQuestions = JSON.parse(JSON.stringify(question.childrenQuestions));
                const deductibleType = params?.optionalParams?.find(param => param.name === 'deductibleType');
                question.childrenQuestions = question.childrenQuestions.map(q => {
                    // if (!deductibleType) {
                    //     if (q.idQuestion === 1312) {
                    //         q.answerJson = null;
                    //         q.answer = JSON.stringify(coverages);
                    //     }
                    //     if (q.idQuestion === 1313) {
                    //         q.answerJson = null;
                    //         q.answer = JSON.stringify(interpolationLimits);
                    //     }
                    // } else {
                    const idQuestion = deductibleType?.value === 'FN' ? 1388 : 1390;
                    if (q.idQuestion === 1388) {
                        q.answer = JSON.stringify(coverages);
                    } else if (q.idQuestion === 1387 && interpolationLimits?.length) {
                        q.answer = JSON.stringify(interpolationLimits);
                    }
                    //}
                    return q;
                });

                filteredQuestionnaire = filteredQuestionnaire.map(q => {
                    if (q.key === question.key) q = question;
                    return q;
                });
            }
        }

        setTimeout(() => setForceLoading(false), 2000);

        if (question && value) {
            setFilteredQuestionnaire && setFilteredQuestionnaire(filteredQuestionnaire);
            return filteredQuestionnaire
        }
    }

    useEffect(() => {
        useGetDocumentsParamsRequest(null, { idDomain: [734] });
    }, []);

    useEffect(() => {
        if (useGetDocumentsParamsStatus === 200) {
            setInvalidEmails(useGetDocumentsParamsData.value[0].documentMetadata.recipientDeniedList);
        }
    }, [useGetDocumentsParamsStatus]);

    useEffect(() => {
        buildValidation();
    }, [questionnaire, partners, externalEntityGroup, beneficiary, coInsuredGroup, cashCollateralGroup, coInsurerGroup]);

    useEffect(() => {
        setHasPermission((operation?.idOperation && !EDIT_PERMISSION) || (!operation?.idOperation && !permissions.CREATE_ENQUIRY));
    }, [permissions, operation?.idOperation, EDIT_PERMISSION]);


    const handleCalculateCoInsurersPercentage = (setFieldValue) => {
        try {
            const percentageTaxes = coInsurerGroup.map(item => item.filter(i => i.idQuestion === 1576));

            let total = 0;
            for (let percentage of percentageTaxes) {
                for (let perc of percentage) {
                    total += Number(perc?.answer);
                }
            }

            let percentageCalcAmount = 0;
            let stateTotal = 0;
            setQuestionnaire(questionnaire.map(qst => {
                if (qst.idQuestion === 1804) {
                    percentageCalcAmount = 100 - total;

                    qst.answer = total === 100 ? '0' : percentageCalcAmount;
                    setFieldValue && setFieldValue(qst.key, qst.answer);
                }

                return qst;
            }));

            stateTotal = total + percentageCalcAmount;
            setTotalPercentage(stateTotal);
        } catch (e) {
            console.log(e);
        }
    }

    const handleTitleFormData = (idDomain) => {
        if (idDomain === 254) {
            if (operation?.idDomainStatus === 178) return 'Endosso Sem Movimento - Novo Endosso';
            return 'Endosso Sem Movimento - Editar Endosso';
        } else if (idDomain === 400) {
            if (operation?.idDomainStatus === 141) return 'Cancelamento - Novo Endosso';
            return 'Cancelamento - Editar Endosso';
        } else if (idDomain === 398) {
            if (operation?.idDomainStatus === 116) return 'Endosso Com Movimento - Novo Endosso';
            return 'Endosso Com Movimento - Editar Endosso';
        } else if (idDomain === 26) {
            return operation?.idOperation ? "Editar Cotação" : "Nova Cotação"
        }
    }

    const handleCheckConsumption = async ({ idPerson }) => {
        try {
            let consumptionData;

            if (idPerson) {
                const { data: { value: { idOperation } } } = await useGetBorrowerByIdPersonRequest(
                    {},
                    { borrowerPersonId: idPerson }
                );

                if (idOperation) {
                    const { data } = await useCheckConsumptionRequest(
                        {},
                        {
                            isIssue: false,
                            validateOnlyGlobalFinanceBalanceStatus: true
                        },
                        null,
                        `v2/credit-limit/${idOperation}/check-consumption`
                    );
                    consumptionData = data;
                }
            }
            return !!consumptionData?.value?.availableLimit;
        } catch (err) {
            if (err?.response?.data?.errors?.length) {
                err?.response?.data?.errors.map(error => mc.error(error.message))
            } else {
                mc.error(`Falha ao confirmar ${operation?.idDomain === 398 ? 'o seu endosso' : 'a sua cotação'}, tente novamente!`);
            }
            return false;
        }
    }

    const handleGetProductPlanVigencyParams = async ({
        idProductPlan,
        idDomainOperation,
        inceptionDate
    }) => {
        const vigencyParamsData = {
            productPlanVigencyMin: null,
            productPlanVigencyMax: null,
            productPlanVigencyDefault: null,
            maxRetroactiveDate: null
        };

        if (!idProductPlan) return vigencyParamsData;
        try {
            const { data: { value: {
                productPlanVigencyMin,
                productPlanVigencyMax,
                productPlanVigencyDefault,
                maxRetroactiveDate
            } } } = await useGetProductPlanVigencyParamsSyncRequest(
                {},
                {
                    idProductPlan,
                    idDomainOperation,
                    inceptionDate
                }
            );
            vigencyParamsData.productPlanVigencyMin = productPlanVigencyMin;
            vigencyParamsData.productPlanVigencyMax = productPlanVigencyMax;
            vigencyParamsData.productPlanVigencyDefault = productPlanVigencyDefault;
            vigencyParamsData.maxRetroactiveDate = maxRetroactiveDate;
            vigencyParams.current = vigencyParamsData;
        } catch (err) {
            if (err?.response?.data?.errors?.length) {
                err?.response?.data?.errors.map(error => mc.error(error.message))
            } else {
                mc.error(`Falha ao buscar os parâmetros da vigência!`);
            }
        } finally {
            return vigencyParamsData;
        }
    }

    return (
        <Layout
            title={handleTitleFormData(operation?.idDomain)}
            subtitle={`${product?.PRODUCT_NAME || operation?.productName || ""}`}
            idOperation={operation?.idOperation}
            idProduct={operation?.idProduct}
        >
            <StepNavigation
                stage={1}
                idOperation={match?.params?.idOperation}
                permissions={permissions}
            />

            <BrokingSummary
                idOperation={match?.params?.idOperation}
                history={history}
                permissions={permissions}
            />

            <NotesModal
                title={'Informações Adicionais'}
                textButtonConfirm={'Confirmar'}
                textButtonCancel={'Cancelar'}
                show={notesModal}
                setModalShow={setNotesModal}
                customCancelButton={[Colors.WHITE, Colors.PRIMARY1]}
                idOperation={idOperation}
                idQuestion={1812}
                functionCallback={async () => {
                    if (operation?.idDOmain !== 400) {
                        await useResetOperationStateRequest({ idDomainOrigin: 26 });
                    }

                    const { status } = await useUpdateOperationRequest({
                        idDomainStatus: operation?.idDomain === 26 ? 4 :
                            operation?.idDomain === 254 ? 443 :
                                operation?.idDomain === 398 ? 448 :
                                    operation?.idDomain === 400 ? 447 :
                                        null
                    });

                    if (status === 200) history.push(operation?.idDomain === 26 ? '/enquiries' : '/polices');
                }}
            />

            <ModalConfirmation
                show={modalConfirmation}
                text="Caso confirme, este campo será bloqueado e os outros campos serão habilitados para edição"
                showTitle={false}
                textButtonCancel="CANCELAR"
                textButtonConfirm="CONFIRMAR"
                onConfirm={() => {
                    const question = questionnaire.find(qst => qst.idQuestion === 1854);
                    const answerOption = question.answerOptions.find(
                        opt => opt.dsAnswerOption.toUpperCase() === "SIM"
                    );

                    setQuestionnaire(questionnaire.map(qst => {
                        if (qst.key === question.key) {
                            qst.answer = answerOption.dsAnswerOption;
                            qst.idAnswerOption = answerOption.idAnswerOption;
                            qst.answerJson = undefined;
                            qst.disabled = true
                        }

                        if ([1553, 1558, 1617, 1618, 1619, 1620, 1621, 1622, 1623, 1624, 1625, 1626, 1627, 1628, 1732].includes(qst.idQuestion)) {
                            qst.disabled = answerOption.idAnswerOption != 7466
                            qst.behaviorObject.isReadOnly = answerOption.idAnswerOption != 7466
                        }
                        return qst;
                    }));
                    formikRef.current?.setFieldValue(question.key, answerOption.dsAnswerOption);

                    handleQuestionChange(
                        question,
                        answerOption,
                        questionnaire,
                        setQuestionnaire,
                        formikRef.current?.setFieldValue,
                        setCurrentModality,
                        authContext.token,
                        getPersonRequest,
                        null,
                        null,
                        null,
                        coBrokerGroup,
                        null,
                        useMaxLimClaimRequest
                    )
                    setModalConfirmation(false)
                }}
                onCancel={() => {
                    setModalConfirmation(false)
                }}
            />
            <Formik
                innerRef={formikRef}
                initialValues={{}}
                validateOnChange={false}
                validateOnBlur={false}
                enableReinitialize={true}
            >
                {({ values, setFieldValue, errors, setFieldError }) => (
                    <Form>
                        <GroupFormContainer>
                            {(handleCollapse, collapseAll, collapseChild) => (<div>
                                {sectionIsVisible("SUMMARY", questionnaire, permissions, currentModality, true) &&
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="SUMMARY"
                                        disableAll={disableAll}
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        currentModality={currentModality}
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            questionnaire,
                                            setQuestionnaire,
                                            setFieldValue
                                        )}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => {
                                            if (question.idQuestion === 1854) {
                                                setModalConfirmation(true)
                                            } else {
                                                handleQuestionChange(
                                                    question,
                                                    value,
                                                    questionnaireUpdated,
                                                    setQuestionnaire,
                                                    setFieldValue,
                                                    setCurrentModality,
                                                    authContext.token,
                                                    getPersonRequest,
                                                    null,
                                                    mc,
                                                    null,
                                                    coBrokerGroup,
                                                    null,
                                                    useMaxLimClaimRequest,
                                                    operation ?? null,
                                                    null,
                                                    systemDateReference,
                                                    null,
                                                    handleGetProductPlanVigencyParams,
                                                    vigencyParams.current
                                                )
                                            }
                                        }}
                                        permissions={permissions}
                                        selectedBrokers={selectedBrokers}
                                        debounceSearchRequest={false}
                                        notChangeQuestions={[1854]}
                                    />}

                                {sectionIsVisible("BORROWER_CLAIMANT", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"1"}
                                    title="Dados do Proponente / Tomador"
                                    noTitlePadding
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="BORROWER_CLAIMANT"
                                        disableAll={
                                            disableAll ||
                                            operation?.idDomain === 400 ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreModality
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            questionnaire,
                                            setQuestionnaire,
                                            setFieldValue
                                        )}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            useMaxLimClaimRequest,
                                            operation ?? null,
                                            null,
                                            null,
                                            handleCheckConsumption,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>}

                                {sectionIsVisible("BORROWER", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"2"}
                                    noTitlePadding
                                    title="Dados do Proponente / Tomador"
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="BORROWER"
                                        disableAll={
                                            disableAll ||
                                            operation?.idDomain === 400 ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreModality
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            questionnaire,
                                            setQuestionnaire,
                                            setFieldValue
                                        )}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            useMaxLimClaimRequest,
                                            operation ?? null,
                                            null,
                                            null,
                                            handleCheckConsumption,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>}

                                {sectionIsVisible("INSURED", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"3"}
                                    title="Segurado"
                                    noTitlePadding
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="INSURED"
                                        disableAll={
                                            disableAll ||
                                            operation?.idDomain === 400 ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        currentModality={currentModality}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        onSearchZipCode={(zipCode, setFieldValue, rootQuestion) => handleSearchZipCode(rootQuestion, zipCode, questionnaire, setQuestionnaire, setFieldValue)}
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            questionnaire,
                                            setQuestionnaire,
                                            setFieldValue
                                        )}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            operation ?? null,
                                            null,
                                            systemDateReference,
                                            null,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>}

                                {sectionIsVisible("CO_INSURED", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"4"}
                                    title="Co-segurado"
                                    noTitlePadding
                                >
                                    {coInsuredGroup.map((questions, index) => (
                                        <FormSection
                                            setQuestionnaire={(questionnaire) => setCoInsuredGroup(coInsuredGroup.map((v, i) => i === index ? questionnaire : v))}
                                            sectionName="CO_INSURED"
                                            disableAll={
                                                disableAll ||
                                                operation?.idDomain === 400 ||
                                                notEditRiskOnRenewal
                                            }
                                            showWarning={isAwaitingAnalysis || !isEdit}
                                            idProduct={match.params.idProduct}
                                            values={values}
                                            errors={errors}
                                            currentModality={currentModality}
                                            setFieldValue={setFieldValue}
                                            setFieldError={setFieldError}
                                            sectionIndex={index}
                                            questionnaire={questions}
                                            formikRef={formikRef}
                                            onSearchZipCode={(zipCode, setFieldValue, rootQuestion) => handleSearchZipCode(rootQuestion, zipCode, questions, (questionnaire) => setCoInsuredGroup(coInsuredGroup.map((v, i) => i === index ? questionnaire : v)), setFieldValue)}
                                            extraButtons={() => renderAddAndRemoveButtons(
                                                coInsuredGroup,
                                                index,
                                                questions,
                                                setCoInsuredGroup,
                                                "$ANSWERS_CO_INSURED_0",
                                                [254, 398, 400].includes(operation?.idDomain) && !(index + 1 > coInsuredNumber)
                                            )}
                                            idOperation={match?.params?.idOperation}
                                            idOperationParent={match?.params?.idOperationParent}
                                            onRequestSerproCnpj={(
                                                question,
                                                data,
                                                setFieldValue
                                            ) => handleRequestSerproCnpj(
                                                question,
                                                data,
                                                questions,
                                                (questionnaire) => setCoInsuredGroup(coInsuredGroup.map((v, i) => i === index ? questionnaire : v)),
                                                setFieldValue
                                            )}
                                            onQuestionChange={(
                                                question,
                                                value,
                                                setFieldValue,
                                                questionnaireUpdated
                                            ) => handleQuestionChange(
                                                question,
                                                value,
                                                questionnaireUpdated,
                                                (questionnaire) => setCoInsuredGroup(coInsuredGroup.map((v, i) => i === index ? questionnaire : v)),
                                                setFieldValue,
                                                setCurrentModality,
                                                authContext.token,
                                                getPersonRequest,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                operation ?? null,
                                                null,
                                                systemDateReference,
                                                null,
                                                handleGetProductPlanVigencyParams,
                                                vigencyParams.current,
                                                setFieldError
                                            )}
                                            permissions={permissions}
                                        />
                                    ))}
                                </FormContainer>}

                                {sectionIsVisible("BENEFICIARY", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"5"}
                                    title="Beneficiário"
                                    noTitlePadding
                                >
                                    {beneficiary.map((questions, index) => (
                                        <FormSection
                                            setQuestionnaire={(questionnaire) => setBeneficiary(beneficiary.map((v, i) => i === index ? questionnaire : v))}
                                            sectionName="BENEFICIARY"
                                            disableAll={
                                                disableAll ||
                                                operation?.idDomain === 400 ||
                                                notEditRiskOnRenewal
                                            }
                                            showWarning={isAwaitingAnalysis || !isEdit}
                                            idProduct={match.params.idProduct}
                                            values={values}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            setFieldError={setFieldError}
                                            sectionIndex={index}
                                            questionnaire={questions}
                                            formikRef={formikRef}
                                            onSearchZipCode={(zipCode, setFieldValue, rootQuestion) => handleSearchZipCode(rootQuestion, zipCode, questions, (questionnaire) => setBeneficiary(beneficiary.map((v, i) => i === index ? questionnaire : v)), setFieldValue)}
                                            extraButtons={() => renderAddAndRemoveButtons(
                                                beneficiary,
                                                index,
                                                questions,
                                                setBeneficiary,
                                                "$ANSWERS_BENEFICIARY_0",
                                                [254, 398, 400].includes(operation?.idDomain) && !(index + 1 > beneficiaryNumber)
                                            )}
                                            idOperation={match?.params?.idOperation}
                                            idOperationParent={match?.params?.idOperationParent}
                                            ignoreModality
                                            onRequestSerproCnpj={(
                                                question,
                                                data,
                                                setFieldValue
                                            ) => handleRequestSerproCnpj(
                                                question,
                                                data,
                                                questions,
                                                (questionnaire) => setBeneficiary(beneficiary.map((v, i) => i === index ? questionnaire : v)),
                                                setFieldValue
                                            )}
                                            onQuestionChange={(
                                                question,
                                                value,
                                                setFieldValue,
                                                questionnaireUpdated
                                            ) => handleQuestionChange(
                                                question,
                                                value,
                                                questionnaireUpdated,
                                                (questionnaire) => setBeneficiary(beneficiary.map((v, i) => i === index ? questionnaire : v)),
                                                setFieldValue,
                                                setCurrentModality,
                                                authContext.token,
                                                getPersonRequest,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                operation ?? null,
                                                null,
                                                systemDateReference,
                                                null,
                                                handleGetProductPlanVigencyParams,
                                                vigencyParams.current,
                                                setFieldError
                                            )}
                                            permissions={permissions}
                                        />
                                    ))}
                                </FormContainer>}

                                {sectionIsVisible("RISKS", questionnaire, permissions, currentModality) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"6"}
                                    title="Dados do Risco"
                                    noTitlePadding
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="RISKS"
                                        disableAll={
                                            disableAll ||
                                            operation?.idDomain === 400 ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        currentModality={currentModality}
                                        onSearchZipCode={(zipCode, setFieldValue, rootQuestion) => handleSearchZipCode(rootQuestion, zipCode, questionnaire, setQuestionnaire, setFieldValue)}
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            questionnaire,
                                            setQuestionnaire,
                                            setFieldValue
                                        )}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            operation ?? null,
                                            null,
                                            systemDateReference,
                                            null,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError
                                        )}
                                        permissions={permissions}
                                    />
                                    {/* <FormContainer
                                        toggle={collapseAll}
                                        enumerate={"6"}
                                        title="Dados do Risco"
                                        noTitlePadding
                                    > */}
                                        {riskGroup.map((questions, index) => (
                                            <FormSection
                                                setQuestionnaire={(questionnaire) => setRiskGroup(riskGroup.map((v, i) => i === index ? questionnaire : v))}
                                                sectionName="RISK_LOCATION"
                                                disableAll={
                                                    disableAll ||
                                                    operation?.idDomain === 400 ||
                                                    notEditRiskOnRenewal
                                                }
                                                showWarning={isAwaitingAnalysis || !isEdit}
                                                idProduct={match.params.idProduct}
                                                values={values}
                                                errors={errors}
                                                currentModality={currentModality}
                                                setFieldValue={setFieldValue}
                                                setFieldError={setFieldError}
                                                sectionIndex={index}
                                                questionnaire={questions}
                                                formikRef={formikRef}
                                                onSearchZipCode={(zipCode, setFieldValue, rootQuestion) => handleSearchZipCode(rootQuestion, zipCode, questions, (questionnaire) => setRiskGroup(riskGroup.map((v, i) => i === index ? questionnaire : v)), setFieldValue)}
                                                extraButtons={() => renderAddAndRemoveButtons(
                                                    riskGroup,
                                                    index,
                                                    questions,
                                                    setRiskGroup,
                                                    "$ANSWERS_RISK_LOCATION_0",
                                                    [254, 398, 400].includes(operation?.idDomain) && !(index + 1 > riskGroupNumber)
                                                )}
                                                idOperation={match?.params?.idOperation}
                                                idOperationParent={match?.params?.idOperationParent}
                                                onQuestionChange={(
                                                    question,
                                                    value,
                                                    setFieldValue,
                                                    questionnaireUpdated
                                                ) => handleQuestionChange(
                                                    question,
                                                    value,
                                                    questionnaireUpdated,
                                                    (questionnaire) => setRiskGroup(riskGroup.map((v, i) => i === index ? questionnaire : v)),
                                                    setFieldValue,
                                                    setCurrentModality,
                                                    authContext.token,
                                                    getPersonRequest,
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    operation ?? null,
                                                    null,
                                                    systemDateReference,
                                                    null,
                                                    handleGetProductPlanVigencyParams,
                                                    vigencyParams.current,
                                                    setFieldError
                                                )}
                                                permissions={permissions}
                                            />
                                        ))}
                                    {/* </FormContainer> */}
                                </FormContainer>}

                                {sectionIsVisible("PROCESS", questionnaire, permissions, currentModality) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"7"}
                                    title="Dados do Processo"
                                    noTitlePadding
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="PROCESS"
                                        disableAll={
                                            disableAll ||
                                            operation?.idDomain === 400 ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        questionnaire={questionnaire}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        currentModality={currentModality}
                                        onBlur={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionBlur(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            mc,
                                            useGetDatajudProcessInfoRequest
                                        )}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            useMaxLimClaimRequest,
                                            operation,
                                            isCorrectedAmountUpdatable,
                                            systemDateReference,
                                            null,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>}

                                {sectionIsVisible("CONTRACT", questionnaire, permissions, currentModality) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"8"}
                                    title="Dados do Contrato"
                                    noTitlePadding
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="CONTRACT"
                                        disableAll={
                                            disableAll ||
                                            operation?.idDomain === 400 ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        questionnaire={questionnaire}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        currentModality={currentModality}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            operation ?? null,
                                            null,
                                            systemDateReference,
                                            null,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError,
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>}

                                {sectionIsVisible("LEGAL", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"9"}
                                    title="Parecer Jurídico"
                                    noTitlePadding
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="LEGAL"
                                        disableAll={
                                            disableAll ||
                                            operation?.idDomain === 400 ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        questionnaire={questionnaire}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        currentModality={currentModality}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            operation ?? null,
                                            null,
                                            systemDateReference,
                                            null,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>}

                                {sectionIsVisible("INFORMATION", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"10"}
                                    title="Dados do Patrocinador da Causa"
                                    noTitlePadding
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="INFORMATION"
                                        disableAll={
                                            disableAll ||
                                            operation?.idDomain === 400 ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        questionnaire={questionnaire}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        formikRef={formikRef}
                                        idOperationParent={match?.params?.idOperationParent}
                                        idProduct={match.params.idProduct}
                                        currentModality={currentModality}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            null,
                                            operation ?? null,
                                            null,
                                            systemDateReference,
                                            null,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>}

                                {sectionIsVisible("CASH_COLLATERAL", questionnaire, permissions, currentModality) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"11"}
                                    title="Garantia Colateral"
                                    noTitlePadding
                                >
                                    {cashCollateralGroup.map((questions, index) => (
                                        <FormSection
                                            setQuestionnaire={(questionnaire) => setCashCollateralGroup(cashCollateralGroup.map((v, i) => i === index ? questionnaire : v))}
                                            sectionName="CASH_COLLATERAL"
                                            disableAll={
                                                disableAll ||
                                                operation?.idDomain === 400 ||
                                                notEditRiskOnRenewal
                                            }
                                            showWarning={isAwaitingAnalysis || !isEdit}
                                            idProduct={match.params.idProduct}
                                            values={values}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            setFieldError={setFieldError}
                                            sectionIndex={index}
                                            questionnaire={questions}
                                            formikRef={formikRef}
                                            extraButtons={() => renderAddAndRemoveButtons(
                                                cashCollateralGroup,
                                                index,
                                                questions,
                                                setCashCollateralGroup,
                                                "$ANSWERS_CASH_COLLATERAL_0",
                                                [400].includes(operation?.idDomain)
                                            )}
                                            idOperation={match?.params?.idOperation}
                                            idOperationParent={match?.params?.idOperationParent}
                                            currentModality={currentModality}
                                            onRequestSerproCnpj={(
                                                question,
                                                data,
                                                setFieldValue
                                            ) => handleRequestSerproCnpj(
                                                question,
                                                data,
                                                questions,
                                                (questionnaire) => setCashCollateralGroup(cashCollateralGroup.map((v, i) => i === index ? questionnaire : v)),
                                                setFieldValue
                                            )}
                                            permissions={permissions}
                                        />
                                    ))}
                                </FormContainer>}

                                {sectionIsVisible("OPERATION", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"12"}
                                    title="Dados da operação"
                                    noTitlePadding
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="OPERATION"
                                        disableAll={
                                            disableAll ||
                                            notEditRiskOnRenewal
                                        }
                                        showWarning={isAwaitingAnalysis || !isEdit}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        customTagListBg={Colors.PRIMARY1}
                                        currentModality={currentModality}
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            setFieldValue
                                        ) => handleRequestSerproCnpj(
                                            question,
                                            data,
                                            questionnaire,
                                            setQuestionnaire,
                                            setFieldValue
                                        )}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            setCurrentModality,
                                            authContext.token,
                                            getPersonRequest,
                                            null,
                                            mc,
                                            null,
                                            null,
                                            null,
                                            null,
                                            operation,
                                            null,
                                            systemDateReference,
                                            null,
                                            handleGetProductPlanVigencyParams,
                                            vigencyParams.current,
                                            setFieldError,
                                        )}
                                        permissions={permissions}
                                    />

                                    <HasPermission permission={operation?.idDomain === 254}>
                                        <Clauses
                                            idOperation={operation?.idOperation}
                                            idProduct={operation?.idProduct}
                                            idProductPlan={operation?.idProductPlan}
                                            isInAnalysis={false}
                                            noTitlePadding
                                            noTitle
                                            permission={!isBound && permissions.APPROVE_REJECT_ENDORSEMENT}
                                            isLoading={(isLoading) => setClausesLoading(isLoading)}
                                            onSelectClauses={(onSelectClauses) => {
                                                setSelectedClauses(onSelectClauses)
                                            }}
                                            clauseVersionNumber={questionnaire.find(qst => [3501].includes(qst.idQuestion) && qst?.answer)?.answer}
                                        />
                                    </HasPermission>
                                </FormContainer>}

                                {sectionIsVisible("CO_BROKER", questionnaire, permissions, currentModality, true) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"13"}
                                    title="Informações do Co-corretor"
                                    noTitlePadding
                                >
                                    {sectionIsVisible("CO_BROKER", questionnaire, permissions, currentModality, true) &&
                                        <FormSection
                                            setQuestionnaire={setQuestionnaire}
                                            sectionName="CO_BROKER"
                                            disableAll={
                                                disableAll ||
                                                notEditRiskOnRenewal
                                            }
                                            showWarning={isAwaitingAnalysis || !isEdit}
                                            idProduct={match.params.idProduct}
                                            values={values}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            setFieldError={setFieldError}
                                            questionnaire={questionnaire}
                                            customTagListBg={Colors.PRIMARY1}
                                            currentModality={currentModality}
                                            onQuestionChange={(
                                                question,
                                                value,
                                                setFieldValue,
                                                questionnaireUpdated
                                            ) => handleQuestionChange(
                                                question,
                                                value,
                                                questionnaireUpdated,
                                                setQuestionnaire,
                                                setFieldValue,
                                                setCurrentModality,
                                                authContext.token,
                                                getPersonRequest,
                                                questionnaire,
                                                null,
                                                setCoBrokerGroup,
                                                coBrokerGroup,
                                                setQuestionnaireAnswersToDelete,
                                                null,
                                                operation,
                                                null,
                                                systemDateReference,
                                                null,
                                                handleGetProductPlanVigencyParams,
                                                vigencyParams.current,
                                                setFieldError
                                            )}
                                            permissions={permissions}
                                            selectedBrokers={selectedBrokers}
                                            debounceSearchRequest={false}
                                        />
                                    }

                                    {coBrokerGroup.map((questions, index) => (
                                        <FormSection
                                            setQuestionnaire={(questionnaire) => setCoBrokerGroup(coBrokerGroup.map((v, i) => i === index ? questionnaire : v))}
                                            sectionName="CO_BROKERS"
                                            disableAll={
                                                disableAll ||
                                                notEditRiskOnRenewal
                                            }
                                            showWarning={isAwaitingAnalysis || !isEdit}
                                            idProduct={match.params.idProduct}
                                            values={values}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            setFieldError={setFieldError}
                                            sectionIndex={index}
                                            questionnaire={questions}
                                            formikRef={formikRef}
                                            extraButtons={() => handleShowButtons(disableAll || notEditRiskOnRenewal || !!!GENERATE_PERMISSION, questions) ?
                                                null :
                                                renderAddAndRemoveButtons(
                                                    coBrokerGroup,
                                                    index,
                                                    questions,
                                                    setCoBrokerGroup,
                                                    "$ANSWERS_CO_BROKERS_0",
                                                    [254, 400].includes(operation?.idDomain) && !(index + 1 > coBrokerNumber)
                                                )
                                            }
                                            idOperation={match?.params?.idOperation}
                                            idOperationParent={match?.params?.idOperationParent}
                                            ignoreModality
                                            onQuestionChange={(
                                                question,
                                                value,
                                                setFieldValue,
                                                questionnaireUpdated
                                            ) => handleQuestionChange(
                                                question,
                                                value,
                                                questionnaireUpdated,
                                                (questionnaire) => setCoBrokerGroup(coBrokerGroup.map((v, i) => i === index ? questionnaire : v)),
                                                setFieldValue,
                                                setCurrentModality,
                                                authContext.token,
                                                getPersonRequest,
                                                questionnaire,
                                                mc,
                                                null,
                                                coBrokerGroup,
                                                null,
                                                null,
                                                operation ?? null,
                                                null,
                                                systemDateReference,
                                                null,
                                                handleGetProductPlanVigencyParams,
                                                vigencyParams.current,
                                                setFieldError
                                            )}
                                            permissions={permissions}
                                            selectedBrokers={selectedBrokers}
                                            debounceSearchRequest={false}
                                        />
                                    ))}
                                </FormContainer>}

                                <HasPermission permission={GENERATE_PERMISSION}>
                                    {sectionIsVisible("CO_INSURER", questionnaire, permissions, currentModality, true) && <FormContainer
                                        toggle={collapseAll}
                                        enumerate={"14"}
                                        title="Informações do Cosseguro"
                                        noTitlePadding
                                    >
                                        {sectionIsVisible("PARTICIPATION", questionnaire, permissions, currentModality, true) &&
                                            <FormSection
                                                setQuestionnaire={setQuestionnaire}
                                                sectionName="PARTICIPATION"
                                                disableAll={
                                                    disableAll ||
                                                    notEditRiskOnRenewal
                                                }
                                                showWarning={isAwaitingAnalysis || !isEdit}
                                                idProduct={match.params.idProduct}
                                                values={values}
                                                errors={errors}
                                                setFieldValue={setFieldValue}
                                                setFieldError={setFieldError}
                                                questionnaire={questionnaire}
                                                customTagListBg={Colors.PRIMARY1}
                                                currentModality={currentModality}
                                                permissions={permissions} />
                                        }

                                        {coInsurerGroup.map((questions, index) => (
                                            <FormSection
                                                setQuestionnaire={(questionnaire) => setCoInsurerGroup(coInsurerGroup.map((v, i) => i === index ? questionnaire : v))}
                                                sectionName="CO_INSURER"
                                                disableAll={
                                                    disableAll ||
                                                    notEditRiskOnRenewal
                                                }
                                                showWarning={isAwaitingAnalysis || !isEdit}
                                                idProduct={match.params.idProduct}
                                                values={values}
                                                errors={errors}
                                                setFieldValue={setFieldValue}
                                                setFieldError={setFieldError}
                                                sectionIndex={index}
                                                questionnaire={questions}
                                                formikRef={formikRef}
                                                extraButtons={() => handleShowButtons(disableAll || notEditRiskOnRenewal || !GENERATE_PERMISSION, questions) ?
                                                    null :
                                                    renderAddAndRemoveButtons(
                                                        coInsurerGroup,
                                                        index,
                                                        questions,
                                                        setCoInsurerGroup,
                                                        "$ANSWERS_CO_INSURER_0",
                                                        [254, 400].includes(operation?.idDomain) && !(index + 1 > coInsurerNumber)
                                                    )}
                                                idOperation={match?.params?.idOperation}
                                                idOperationParent={match?.params?.idOperationParent}
                                                ignoreModality
                                                onQuestionChange={(
                                                    question,
                                                    value,
                                                    setFieldValue,
                                                    questionnaireUpdated
                                                ) => handleQuestionChange(
                                                    question,
                                                    value,
                                                    questionnaireUpdated,
                                                    (questionnaire) => setCoInsurerGroup(coInsurerGroup.map((v, i) => i === index ? questionnaire : v)),
                                                    setFieldValue,
                                                    setCurrentModality,
                                                    authContext.token,
                                                    getPersonRequest,
                                                    questionnaire,
                                                    mc,
                                                    null,
                                                    coBrokerGroup,
                                                    null,
                                                    null,
                                                    operation ?? null,
                                                    null,
                                                    systemDateReference,
                                                    null,
                                                    handleGetProductPlanVigencyParams,
                                                    vigencyParams.current,
                                                    setFieldError
                                                )}
                                                onBlur={(
                                                    question,
                                                    value,
                                                    setFieldValue,
                                                    questionnaireUpdated
                                                ) => handleQuestionBlur(
                                                    question,
                                                    value,
                                                    questionnaireUpdated,
                                                    setQuestionnaire,
                                                    setFieldValue,
                                                    mc,
                                                    useGetDatajudProcessInfoRequest,
                                                    selectedCoInsurersPercentage,
                                                    questionnaire
                                                )}
                                                permissions={permissions}
                                                selectedCoInsurers={selectedCoInsurers}
                                                debounceSearchRequest={false}
                                            />
                                        ))}
                                        <TotalContainer>
                                            <Label width={'200px'} fontSize={16}>Total</Label>
                                            <Label width={'200px'} fontSize={16}>%{totalPercentage ? totalPercentage : '100'}</Label>
                                        </TotalContainer>
                                    </FormContainer>}
                                </HasPermission>

                                <HasPermission permission={[4, 447, 448].includes(operation?.idDomainStatus)}>
                                    {sectionIsVisible("ADDITIONAL_INFORMATION", questionnaire, permissions, currentModality, true) && <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        disableAll={true}
                                        sectionName={'ADDITIONAL_INFORMATION'}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreModality
                                        permissions={permissions}
                                    />}
                                </HasPermission>

                                {sectionIsVisible("ATTACHMENT", questionnaire, permissions, currentModality, true) && <FormSection
                                    setQuestionnaire={setQuestionnaire}
                                    disableAll={disableAll}
                                    showWarning={isAwaitingAnalysis || !isEdit}
                                    sectionName={'ATTACHMENT'}
                                    idProduct={match.params.idProduct}
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    setFieldError={setFieldError}
                                    questionnaire={questionnaire}
                                    ignoreTypeOfApplication
                                    periodicityOptions={[4632, 4633]}
                                    periodicityText={periodicityText}
                                    customTagListBg={Colors.PRIMARY1}
                                    permissions={permissions}
                                />}
                            </div>)}
                        </GroupFormContainer>
                        {sectionIsVisible("ANALYSIS_INFO", questionnaire) &&
                            <FormSection
                                setQuestionnaire={setQuestionnaire}
                                sectionName="ANALYSIS_INFO"
                                disableAll={isBound || isAwaitingAnalysis || hasPermission || !isEdit}
                                showWarning={isAwaitingAnalysis || !isEdit}
                                questionnaire={questionnaire}
                                values={values}
                                setFieldValue={setFieldValue}
                                setFieldError={setFieldError}
                                formikRef={formikRef}
                                idOperationParent={match?.params?.idOperationParent}
                                idProduct={match.params.idProduct}
                                currentModality={currentModality}
                                onQuestionChange={(
                                    question,
                                    value,
                                    setFieldValue,
                                    questionnaireUpdated
                                ) => handleQuestionChange(
                                    question,
                                    value,
                                    questionnaireUpdated,
                                    setQuestionnaire,
                                    setFieldValue,
                                    setCurrentModality,
                                    authContext.token,
                                    getPersonRequest,
                                    null,
                                    null,
                                    coBrokerGroup,
                                    null,
                                    null,
                                    null,
                                    operation ?? null,
                                    null,
                                    systemDateReference,
                                    null,
                                    handleGetProductPlanVigencyParams,
                                    vigencyParams.current,
                                    setFieldError
                                )}
                                permissions={permissions}
                            />
                        }

                        <ButtonContainer>
                            <Button forth onClick={() => handleBack()}> &lt; VOLTAR PARA LISTA</Button>
                            <HasPermission permission={!isBound}>
                                <ButtonContent>
                                    {(operation?.idOperation) && 
                                    <HasPermission permission={CANCEL_ENDORSEMENT}>
                                        <LostCancelButton idQuestion={3458} idOperation={match?.params?.idOperation} idDomain={operation?.idDomain} redirectTo={"/list"} />
                                    </HasPermission>}

                                    <HasPermission
                                        permission={
                                            operation?.idOperation &&
                                            [8, 10, 443, 444, 445].includes(operation?.idDomainStatus) &&
                                            permissions.REQUEST_ADDITIONAL_INFO
                                        }
                                    >
                                        <Button
                                            type="button"
                                            onClick={() => setNotesModal(true)}
                                            third
                                        >
                                            MAIS INFO
                                        </Button>
                                    </HasPermission>

                                    <HasPermission permission={
                                        ((operation?.idOperation && EDIT_PERMISSION) || (!operation?.idOperation && permissions.CREATE_ENQUIRY)) &&
                                        (!operation?.idOperation || [1, 7, 116, 126, 141, 151, 178, 384, 443, 444, 445, 447, 448].includes(operation?.idDomainStatus))
                                    }>
                                        <Button
                                            id="btnSave"
                                            type="button"
                                            onClick={() => onSave(values, null, true)}
                                            disabled={disableButton(operation)}
                                            primary
                                        >
                                            SALVAR
                                        </Button>
                                    </HasPermission>

                                    <HasPermission permission={
                                        (!operation?.idOperation ||
                                            ([10].includes(operation?.idDomainStatus) && GENERATE_PERMISSION) ||
                                            (![10].includes(operation?.idDomainStatus) && operation?.idDomain === 26) ||
                                            (([1, 7, 116, 126, 141, 151, 178, 384, 443, 444, 445, 447, 448].includes(operation?.idDomainStatus)) && (permissions.REQUEST_ENDORSEMENT || GENERATE_PERMISSION))) &&
                                        permissions.MARKETING_COMPOSITION
                                    }>
                                        <Button
                                            id="btnSave"
                                            type="button"
                                            onClick={() => onSave(values, 1, false)}
                                            disabled={disableButton(operation)}
                                            custom={[Colors.WHITE, Colors.TERTIARY]}
                                        >
                                            {
                                                operation?.idDomain == 254 ? `${GENERATE_PERMISSION ? "GERAR" : "SOLICITAR"} ENDOSSO` : "CONTINUAR"
                                            }
                                        </Button>
                                    </HasPermission>
                                </ButtonContent>
                            </HasPermission>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Layout >
    )
}